export const loansData = [
  {
    "_id": "pmegp-manufacturing",
    "name": "PMEGP Manufacturing Scheme",
    "slug": "pmegp-manufacturing",
    "category": "government",
    "description": "Credit-linked subsidy to set up new micro manufacturing units.",
    "longDescription": "New manufacturing units. Min VIII pass for projects above 10L.",
    "minAmount": 100000,
    "maxAmount": 5000000,
    "interestRate": "6.0% - 9.5%",
    "processingTime": "10 - 15 working days",
    "tenure": "Up to 7 years",
    "collateral": false,
    "documents": [
      "Aadhaar Card",
      "PAN Card",
      "Project Report",
      "Education Proof"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Apply online on KVIC site",
        "description": "Apply online on KVIC site"
      },
      {
        "step": 2,
        "title": "Upload project",
        "description": "Upload project report & KYC"
      },
      {
        "step": 3,
        "title": "EDP training completion",
        "description": "EDP training completion"
      },
      {
        "step": 4,
        "title": "Bank sanction",
        "description": "Bank sanction and disbursal"
      }
    ],
    "features": [
      "Loan amount up to ₹50 Lakh",
      "Attractive interest rate: 6.0% - 9.5%",
      "Zero collateral needed",
      "Quick processing within 10 - 15 working days"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for PMEGP Manufacturing Scheme?",
        "answer": "Up to ₹50,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "New manufacturing units. Min VIII pass for projects above 10L.",
      "minTurnover": 100000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "sole proprietor",
        "micro-enterprise"
      ]
    },
    "seo": {
      "title": "PMEGP Manufacturing Scheme | MSME Business Funding",
      "description": "Credit-linked subsidy to set up new micro manufacturing units."
    },
    "isActive": true,
    "popular": true
  },
  {
    "_id": "pmegp-service",
    "name": "PMEGP Service Sector Scheme",
    "slug": "pmegp-service",
    "category": "government",
    "description": "Credit-linked subsidy to set up new micro service units.",
    "longDescription": "New service units. Min VIII pass for projects above 5L.",
    "minAmount": 50000,
    "maxAmount": 2000000,
    "interestRate": "6.0% - 9.5%",
    "processingTime": "10 - 15 working days",
    "tenure": "Up to 7 years",
    "collateral": false,
    "documents": [
      "Aadhaar Card",
      "PAN Card",
      "Project Report",
      "Skill Certificate"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Apply online on KVIC site",
        "description": "Apply online on KVIC site"
      },
      {
        "step": 2,
        "title": "Upload project report",
        "description": "Upload project report"
      },
      {
        "step": 3,
        "title": "Verify by DIC",
        "description": "Verify by DIC"
      },
      {
        "step": 4,
        "title": "EDP training and release",
        "description": "EDP training and release"
      }
    ],
    "features": [
      "Loan amount up to ₹20 Lakh",
      "Attractive interest rate: 6.0% - 9.5%",
      "Zero collateral needed",
      "Quick processing within 10 - 15 working days"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for PMEGP Service Sector Scheme?",
        "answer": "Up to ₹20,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "New service units. Min VIII pass for projects above 5L.",
      "minTurnover": 50000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "sole proprietor",
        "freelancer",
        "micro-enterprise"
      ]
    },
    "seo": {
      "title": "PMEGP Service Sector Scheme | MSME Business Funding",
      "description": "Credit-linked subsidy to set up new micro service units."
    },
    "isActive": true,
    "popular": true
  },
  {
    "_id": "mudra-shishu",
    "name": "Pradhan Mantri Mudra Yojana - Shishu",
    "slug": "mudra-shishu",
    "category": "government",
    "description": "Collateral-free micro loans up to Rs. 50k for starting business activities.",
    "longDescription": "Indian citizen running micro business. Age 18-65. No defaults.",
    "minAmount": 1000,
    "maxAmount": 50000,
    "interestRate": "6.0% - 9.5%",
    "processingTime": "10 - 15 working days",
    "tenure": "Up to 7 years",
    "collateral": false,
    "documents": [
      "Aadhaar Card",
      "PAN Card",
      "Business Address Proof",
      "Photos"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Apply on",
        "description": "Apply on Jan Samarth portal"
      },
      {
        "step": 2,
        "title": "Select Shishu category",
        "description": "Select Shishu category"
      },
      {
        "step": 3,
        "title": "Provide personal details",
        "description": "Provide personal details"
      },
      {
        "step": 4,
        "title": "Bank check",
        "description": "Bank check & card disbursal"
      }
    ],
    "features": [
      "Loan amount up to ₹1 Lakh",
      "Attractive interest rate: 6.0% - 9.5%",
      "Zero collateral needed",
      "Quick processing within 10 - 15 working days"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for Pradhan Mantri Mudra Yojana - Shishu?",
        "answer": "Up to ₹50,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "Indian citizen running micro business. Age 18-65. No defaults.",
      "minTurnover": 1000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "sole proprietor",
        "freelancer",
        "micro-enterprise"
      ]
    },
    "seo": {
      "title": "Pradhan Mantri Mudra Yojana - Shishu | MSME Business Funding",
      "description": "Collateral-free micro loans up to Rs. 50k for starting business activities."
    },
    "isActive": true,
    "popular": false
  },
  {
    "_id": "mudra-kishor",
    "name": "Pradhan Mantri Mudra Yojana - Kishor",
    "slug": "mudra-kishor",
    "category": "government",
    "description": "Collateral-free business loans from Rs. 50k to Rs. 5 Lakhs.",
    "longDescription": "Operating micro units looking for growth. Stable vintage of 1 year.",
    "minAmount": 50001,
    "maxAmount": 500000,
    "interestRate": "6.0% - 9.5%",
    "processingTime": "10 - 15 working days",
    "tenure": "Up to 7 years",
    "collateral": false,
    "documents": [
      "Aadhaar",
      "PAN",
      "Business Proof",
      "6 Months Bank Statements"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Apply on",
        "description": "Apply on Jan Samarth portal"
      },
      {
        "step": 2,
        "title": "Select Kishor category",
        "description": "Select Kishor category"
      },
      {
        "step": 3,
        "title": "Upload bank statements",
        "description": "Upload bank statements"
      },
      {
        "step": 4,
        "title": "Verification &",
        "description": "Verification & current account credit"
      }
    ],
    "features": [
      "Loan amount up to ₹5 Lakh",
      "Attractive interest rate: 6.0% - 9.5%",
      "Zero collateral needed",
      "Quick processing within 10 - 15 working days"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for Pradhan Mantri Mudra Yojana - Kishor?",
        "answer": "Up to ₹5,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "Operating micro units looking for growth. Stable vintage of 1 year.",
      "minTurnover": 50001,
      "minCreditScore": 650,
      "additionalCriteria": [
        "sole proprietor",
        "freelancer",
        "micro-enterprise"
      ]
    },
    "seo": {
      "title": "Pradhan Mantri Mudra Yojana - Kishor | MSME Business Funding",
      "description": "Collateral-free business loans from Rs. 50k to Rs. 5 Lakhs."
    },
    "isActive": true,
    "popular": false
  },
  {
    "_id": "mudra-tarun",
    "name": "Pradhan Mantri Mudra Yojana - Tarun",
    "slug": "mudra-tarun",
    "category": "government",
    "description": "Collateral-free credit expansion loans between Rs. 5 Lakhs and Rs. 10 Lakhs.",
    "longDescription": "Business with 2+ years vintage. Steady revenue, GST returns and CIBIL > 650.",
    "minAmount": 500001,
    "maxAmount": 1000000,
    "interestRate": "6.0% - 9.5%",
    "processingTime": "10 - 15 working days",
    "tenure": "Up to 7 years",
    "collateral": false,
    "documents": [
      "PAN Card",
      "GST Returns (6 months)",
      "ITR of 2 years",
      "Financials"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Register on",
        "description": "Register on Jan Samarth portal"
      },
      {
        "step": 2,
        "title": "Select Tarun",
        "description": "Select Tarun and upload ITR & GST"
      },
      {
        "step": 3,
        "title": "Bank financial check",
        "description": "Bank financial check"
      },
      {
        "step": 4,
        "title": "Loan sanction",
        "description": "Loan sanction and disbursal"
      }
    ],
    "features": [
      "Loan amount up to ₹10 Lakh",
      "Attractive interest rate: 6.0% - 9.5%",
      "Zero collateral needed",
      "Quick processing within 10 - 15 working days"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for Pradhan Mantri Mudra Yojana - Tarun?",
        "answer": "Up to ₹10,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "Business with 2+ years vintage. Steady revenue, GST returns and CIBIL > 650.",
      "minTurnover": 500001,
      "minCreditScore": 650,
      "additionalCriteria": [
        "sole proprietor",
        "micro-enterprise",
        "partnership"
      ]
    },
    "seo": {
      "title": "Pradhan Mantri Mudra Yojana - Tarun | MSME Business Funding",
      "description": "Collateral-free credit expansion loans between Rs. 5 Lakhs and Rs. 10 Lakhs."
    },
    "isActive": true,
    "popular": false
  },
  {
    "_id": "stand-up-india",
    "name": "Stand-Up India Scheme",
    "slug": "stand-up-india",
    "category": "government",
    "description": "Loans up to Rs. 1 Crore to SC, ST, or women for greenfield projects.",
    "longDescription": "SC/ST or woman entrepreneur. Greenfield projects only.",
    "minAmount": 1000000,
    "maxAmount": 10000000,
    "interestRate": "6.0% - 9.5%",
    "processingTime": "10 - 15 working days",
    "tenure": "Up to 7 years",
    "collateral": false,
    "documents": [
      "Caste Certificate",
      "Aadhaar Card",
      "PAN Card",
      "Project Report"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Register on",
        "description": "Register on Stand-Up Mitra portal"
      },
      {
        "step": 2,
        "title": "Choose lender",
        "description": "Choose lender branch & upload project details"
      },
      {
        "step": 3,
        "title": "Verification under",
        "description": "Verification under Guarantee Scheme"
      },
      {
        "step": 4,
        "title": "Sanction and release",
        "description": "Sanction and release"
      }
    ],
    "features": [
      "Loan amount up to ₹100 Lakh",
      "Attractive interest rate: 6.0% - 9.5%",
      "Zero collateral needed",
      "Quick processing within 10 - 15 working days"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for Stand-Up India Scheme?",
        "answer": "Up to ₹1,00,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "SC/ST or woman entrepreneur. Greenfield projects only.",
      "minTurnover": 1000000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "sole proprietor",
        "micro-enterprise",
        "partnership"
      ]
    },
    "seo": {
      "title": "Stand-Up India Scheme | MSME Business Funding",
      "description": "Loans up to Rs. 1 Crore to SC, ST, or women for greenfield projects."
    },
    "isActive": true,
    "popular": false
  },
  {
    "_id": "cgtmse-guarantee",
    "name": "CGTMSE Guarantee Scheme",
    "slug": "cgtmse-guarantee",
    "category": "government",
    "description": "Credit guarantee cover facilitating collateral-free bank loans up to Rs. 5 Crores.",
    "longDescription": "New & existing MSMEs. Guarantees default risk, enabling collateral-free bank loans.",
    "minAmount": 100000,
    "maxAmount": 50000000,
    "interestRate": "6.0% - 9.5%",
    "processingTime": "10 - 15 working days",
    "tenure": "Up to 7 years",
    "collateral": false,
    "documents": [
      "Udyam Certificate",
      "PAN Card",
      "Project Report",
      "GST Returns"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Apply for",
        "description": "Apply for business loan at member bank"
      },
      {
        "step": 2,
        "title": "Request loan",
        "description": "Request loan under CGTMSE cover"
      },
      {
        "step": 3,
        "title": "Bank evaluates",
        "description": "Bank evaluates & registers cover"
      },
      {
        "step": 4,
        "title": "Disbursal of",
        "description": "Disbursal of collateral-free loan"
      }
    ],
    "features": [
      "Loan amount up to ₹500 Lakh",
      "Attractive interest rate: 6.0% - 9.5%",
      "Zero collateral needed",
      "Quick processing within 10 - 15 working days"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for CGTMSE Guarantee Scheme?",
        "answer": "Up to ₹5,00,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "New & existing MSMEs. Guarantees default risk, enabling collateral-free bank loans.",
      "minTurnover": 100000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "micro-enterprise",
        "sole proprietor",
        "partnership"
      ]
    },
    "seo": {
      "title": "CGTMSE Guarantee Scheme | MSME Business Funding",
      "description": "Credit guarantee cover facilitating collateral-free bank loans up to Rs. 5 Crores."
    },
    "isActive": true,
    "popular": false
  },
  {
    "_id": "pm-vishwakarma",
    "name": "PM Vishwakarma Scheme",
    "slug": "pm-vishwakarma",
    "category": "government",
    "description": "Collateral-free loans at 5% interest rate for traditional artisans.",
    "longDescription": "Artisans in 18 traditional trades. Min age 18. One per family.",
    "minAmount": 50000,
    "maxAmount": 200000,
    "interestRate": "5.0% (Fixed)",
    "processingTime": "10 - 15 working days",
    "tenure": "Up to 3 years",
    "collateral": false,
    "documents": [
      "Aadhaar Card",
      "Bank Passbook",
      "Artisan Code",
      "Ration Card"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Enroll at",
        "description": "Enroll at local CSC center"
      },
      {
        "step": 2,
        "title": "3-step local",
        "description": "3-step local verification check"
      },
      {
        "step": 3,
        "title": "Get training",
        "description": "Get training and Rs. 15,000 toolkit grant"
      },
      {
        "step": 4,
        "title": "Apply for",
        "description": "Apply for Tranche 1 (1L) & Tranche 2 (1L)"
      }
    ],
    "features": [
      "Loan amount up to ₹2 Lakh",
      "Attractive interest rate: 5.0% (Fixed)",
      "Zero collateral needed",
      "Quick processing within 10 - 15 working days"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for PM Vishwakarma Scheme?",
        "answer": "Up to ₹2,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "Artisans in 18 traditional trades. Min age 18. One per family.",
      "minTurnover": 50000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "sole proprietor",
        "freelancer",
        "micro-enterprise"
      ]
    },
    "seo": {
      "title": "PM Vishwakarma Scheme | MSME Business Funding",
      "description": "Collateral-free loans at 5% interest rate for traditional artisans."
    },
    "isActive": true,
    "popular": false
  },
  {
    "_id": "pmfme-subsidy",
    "name": "PMFME Subsidy Scheme",
    "slug": "pmfme-subsidy",
    "category": "government",
    "description": "Credit-linked subsidy of 35% up to Rs. 10 Lakhs for food processing units.",
    "longDescription": "Individual micro food processors. Existing or new food units. Age 18+.",
    "minAmount": 100000,
    "maxAmount": 10000000,
    "interestRate": "6.0% - 9.5%",
    "processingTime": "10 - 15 working days",
    "tenure": "Up to 7 years",
    "collateral": false,
    "documents": [
      "Aadhaar",
      "PAN",
      "Project Report",
      "FSSAI Certificate"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Apply on PMFME portal",
        "description": "Apply on PMFME portal"
      },
      {
        "step": 2,
        "title": "Fill details",
        "description": "Fill details & upload project report & FSSAI"
      },
      {
        "step": 3,
        "title": "Resource person",
        "description": "Resource person verifies & bank sanctions"
      }
    ],
    "features": [
      "Loan amount up to ₹100 Lakh",
      "Attractive interest rate: 6.0% - 9.5%",
      "Zero collateral needed",
      "Quick processing within 10 - 15 working days"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for PMFME Subsidy Scheme?",
        "answer": "Up to ₹1,00,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "Individual micro food processors. Existing or new food units. Age 18+.",
      "minTurnover": 100000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "micro-enterprise",
        "sole proprietor",
        "partnership"
      ]
    },
    "seo": {
      "title": "PMFME Subsidy Scheme | MSME Business Funding",
      "description": "Credit-linked subsidy of 35% up to Rs. 10 Lakhs for food processing units."
    },
    "isActive": true,
    "popular": true
  },
  {
    "_id": "sidbi-smile",
    "name": "SIDBI SMILE Scheme",
    "slug": "sidbi-smile",
    "category": "government",
    "description": "Soft and term loans for MSMEs to maintain a healthy debt-equity ratio.",
    "longDescription": "Mfg or service MSMEs. Min 6 months vintage. Debt-equity ratio <= 3:1.",
    "minAmount": 1000000,
    "maxAmount": 2500000,
    "interestRate": "6.0% - 9.5%",
    "processingTime": "10 - 15 working days",
    "tenure": "Up to 7 years",
    "collateral": false,
    "documents": [
      "PAN Card",
      "Audited Financials",
      "ITR returns",
      "Udyam Certificate"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Apply on",
        "description": "Apply on SIDBI online portal"
      },
      {
        "step": 2,
        "title": "Fill details",
        "description": "Fill details & upload financials & report"
      },
      {
        "step": 3,
        "title": "SIDBI credit",
        "description": "SIDBI credit appraisal & disbursal"
      }
    ],
    "features": [
      "Loan amount up to ₹25 Lakh",
      "Attractive interest rate: 6.0% - 9.5%",
      "Zero collateral needed",
      "Quick processing within 10 - 15 working days"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for SIDBI SMILE Scheme?",
        "answer": "Up to ₹25,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "Mfg or service MSMEs. Min 6 months vintage. Debt-equity ratio <= 3:1.",
      "minTurnover": 1000000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "micro-enterprise",
        "sole proprietor",
        "partnership"
      ]
    },
    "seo": {
      "title": "SIDBI SMILE Scheme | MSME Business Funding",
      "description": "Soft and term loans for MSMEs to maintain a healthy debt-equity ratio."
    },
    "isActive": true,
    "popular": false
  },
  {
    "_id": "nsfdc-self-employment",
    "name": "NSFDC Self-Employment Loan",
    "slug": "nsfdc-self-employment",
    "category": "government",
    "description": "Concessional term loans up to Rs. 30 Lakhs for Scheduled Caste beneficiaries.",
    "longDescription": "SC category members. Families with low income. Age 18+.",
    "minAmount": 50000,
    "maxAmount": 3000000,
    "interestRate": "6.0% - 9.5%",
    "processingTime": "10 - 15 working days",
    "tenure": "Up to 7 years",
    "collateral": false,
    "documents": [
      "SC Caste Certificate",
      "Aadhaar Card",
      "Income Certificate",
      "Project Profile"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Apply to",
        "description": "Apply to local State Channelizing Agency (SCA)"
      },
      {
        "step": 2,
        "title": "SCA verifies",
        "description": "SCA verifies credentials and forwards to NSFDC"
      },
      {
        "step": 3,
        "title": "Disbursal via SCA",
        "description": "Disbursal via SCA"
      }
    ],
    "features": [
      "Loan amount up to ₹30 Lakh",
      "Attractive interest rate: 6.0% - 9.5%",
      "Zero collateral needed",
      "Quick processing within 10 - 15 working days"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for NSFDC Self-Employment Loan?",
        "answer": "Up to ₹30,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "SC category members. Families with low income. Age 18+.",
      "minTurnover": 50000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "sole proprietor",
        "freelancer",
        "micro-enterprise"
      ]
    },
    "seo": {
      "title": "NSFDC Self-Employment Loan | MSME Business Funding",
      "description": "Concessional term loans up to Rs. 30 Lakhs for Scheduled Caste beneficiaries."
    },
    "isActive": true,
    "popular": false
  },
  {
    "_id": "nbcfdc-self-employment",
    "name": "NBCFDC Self-Employment Loan",
    "slug": "nbcfdc-self-employment",
    "category": "government",
    "description": "Concessional term loans up to Rs. 15 Lakhs for OBC beneficiaries.",
    "longDescription": "OBC category applicant. Family income under Rs. 3 Lakhs.",
    "minAmount": 50000,
    "maxAmount": 1500000,
    "interestRate": "6.0% - 9.5%",
    "processingTime": "10 - 15 working days",
    "tenure": "Up to 7 years",
    "collateral": false,
    "documents": [
      "OBC Certificate",
      "Aadhaar Card",
      "Income Proof",
      "Project Brief"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Apply at",
        "description": "Apply at local State Channelising Agency (SCA)"
      },
      {
        "step": 2,
        "title": "Submit proofs",
        "description": "Submit proofs and project proposal"
      },
      {
        "step": 3,
        "title": "SCA sanctions",
        "description": "SCA sanctions & releases loan"
      }
    ],
    "features": [
      "Loan amount up to ₹15 Lakh",
      "Attractive interest rate: 6.0% - 9.5%",
      "Zero collateral needed",
      "Quick processing within 10 - 15 working days"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for NBCFDC Self-Employment Loan?",
        "answer": "Up to ₹15,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "OBC category applicant. Family income under Rs. 3 Lakhs.",
      "minTurnover": 50000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "sole proprietor",
        "freelancer",
        "micro-enterprise"
      ]
    },
    "seo": {
      "title": "NBCFDC Self-Employment Loan | MSME Business Funding",
      "description": "Concessional term loans up to Rs. 15 Lakhs for OBC beneficiaries."
    },
    "isActive": true,
    "popular": false
  },
  {
    "_id": "nmdfc-self-employment",
    "name": "NMDFC Self-Employment Loan",
    "slug": "nmdfc-self-employment",
    "category": "government",
    "description": "Concessional term loans up to Rs. 30 Lakhs for minority community members.",
    "longDescription": "Belongs to notified minority community. Family income < Rs. 8L.",
    "minAmount": 50000,
    "maxAmount": 3000000,
    "interestRate": "6.0% - 9.5%",
    "processingTime": "10 - 15 working days",
    "tenure": "Up to 7 years",
    "collateral": false,
    "documents": [
      "Minority Certificate",
      "Aadhaar Card",
      "Income Proof",
      "Project Brief"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Apply via",
        "description": "Apply via State Channelising Agency (SCA)"
      },
      {
        "step": 2,
        "title": "Submit community",
        "description": "Submit community and income certificates"
      },
      {
        "step": 3,
        "title": "SCA checks & disburses",
        "description": "SCA checks & disburses"
      }
    ],
    "features": [
      "Loan amount up to ₹30 Lakh",
      "Attractive interest rate: 6.0% - 9.5%",
      "Zero collateral needed",
      "Quick processing within 10 - 15 working days"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for NMDFC Self-Employment Loan?",
        "answer": "Up to ₹30,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "Belongs to notified minority community. Family income < Rs. 8L.",
      "minTurnover": 50000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "sole proprietor",
        "freelancer",
        "micro-enterprise"
      ]
    },
    "seo": {
      "title": "NMDFC Self-Employment Loan | MSME Business Funding",
      "description": "Concessional term loans up to Rs. 30 Lakhs for minority community members."
    },
    "isActive": true,
    "popular": false
  },
  {
    "_id": "nskfdc-self-employment",
    "name": "NSKFDC Self-Employment Loan",
    "slug": "nskfdc-self-employment",
    "category": "government",
    "description": "Concessional loans up to Rs. 15 Lakhs for Safai Karamcharis and scavengers.",
    "longDescription": "Safai Karamcharis, manual scavengers, and dependents. No income limits.",
    "minAmount": 50000,
    "maxAmount": 1500000,
    "interestRate": "6.0% - 9.5%",
    "processingTime": "10 - 15 working days",
    "tenure": "Up to 7 years",
    "collateral": false,
    "documents": [
      "Aadhaar Card",
      "Occupation Certificate",
      "Project Report",
      "Bank Details"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Apply through local SCA",
        "description": "Apply through local SCA"
      },
      {
        "step": 2,
        "title": "Provide municipal",
        "description": "Provide municipal worker certification"
      },
      {
        "step": 3,
        "title": "SCA reviews",
        "description": "SCA reviews proposal and releases funds"
      }
    ],
    "features": [
      "Loan amount up to ₹15 Lakh",
      "Attractive interest rate: 6.0% - 9.5%",
      "Zero collateral needed",
      "Quick processing within 10 - 15 working days"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for NSKFDC Self-Employment Loan?",
        "answer": "Up to ₹15,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "Safai Karamcharis, manual scavengers, and dependents. No income limits.",
      "minTurnover": 50000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "sole proprietor",
        "freelancer",
        "micro-enterprise"
      ]
    },
    "seo": {
      "title": "NSKFDC Self-Employment Loan | MSME Business Funding",
      "description": "Concessional loans up to Rs. 15 Lakhs for Safai Karamcharis and scavengers."
    },
    "isActive": true,
    "popular": false
  },
  {
    "_id": "maharashtra-cmegp-manufacturing",
    "name": "Maharashtra CMEGP - Manufacturing",
    "slug": "maharashtra-cmegp-manufacturing",
    "category": "government",
    "description": "State credit-linked subsidy up to 35% for new manufacturing units.",
    "longDescription": "Maharashtra domicile. VIII pass (for projects >10L). Age 18-45.",
    "minAmount": 100000,
    "maxAmount": 5000000,
    "interestRate": "6.0% - 9.5%",
    "processingTime": "10 - 15 working days",
    "tenure": "Up to 7 years",
    "collateral": false,
    "documents": [
      "Domicile Proof",
      "Aadhaar",
      "Detailed Project Report",
      "Education Certificate"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Register on",
        "description": "Register on MAITRI portal online"
      },
      {
        "step": 2,
        "title": "Upload details",
        "description": "Upload details and project report"
      },
      {
        "step": 3,
        "title": "DIC verification",
        "description": "DIC verification and bank sanction"
      }
    ],
    "features": [
      "Loan amount up to ₹50 Lakh",
      "Attractive interest rate: 6.0% - 9.5%",
      "Zero collateral needed",
      "Quick processing within 10 - 15 working days"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for Maharashtra CMEGP - Manufacturing?",
        "answer": "Up to ₹50,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "Maharashtra domicile. VIII pass (for projects >10L). Age 18-45.",
      "minTurnover": 100000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "micro-enterprise",
        "sole proprietor"
      ]
    },
    "seo": {
      "title": "Maharashtra CMEGP - Manufacturing | MSME Business Funding",
      "description": "State credit-linked subsidy up to 35% for new manufacturing units."
    },
    "isActive": true,
    "popular": true
  },
  {
    "_id": "maharashtra-cmegp-service",
    "name": "Maharashtra CMEGP - Service Sector",
    "slug": "maharashtra-cmegp-service",
    "category": "government",
    "description": "State credit-linked subsidy up to 35% for new service units.",
    "longDescription": "Maharashtra domicile. VIII pass (for projects >5L). Age 18-45.",
    "minAmount": 50000,
    "maxAmount": 2000000,
    "interestRate": "6.0% - 9.5%",
    "processingTime": "10 - 15 working days",
    "tenure": "Up to 7 years",
    "collateral": false,
    "documents": [
      "Domicile Proof",
      "Aadhaar",
      "Project Report",
      "Education Certificate"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Apply via MAITRI portal",
        "description": "Apply via MAITRI portal"
      },
      {
        "step": 2,
        "title": "Submit service",
        "description": "Submit service sector CMEGP application"
      },
      {
        "step": 3,
        "title": "DIC review",
        "description": "DIC review and bank release"
      }
    ],
    "features": [
      "Loan amount up to ₹20 Lakh",
      "Attractive interest rate: 6.0% - 9.5%",
      "Zero collateral needed",
      "Quick processing within 10 - 15 working days"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for Maharashtra CMEGP - Service Sector?",
        "answer": "Up to ₹20,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "Maharashtra domicile. VIII pass (for projects >5L). Age 18-45.",
      "minTurnover": 50000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "micro-enterprise",
        "sole proprietor",
        "freelancer"
      ]
    },
    "seo": {
      "title": "Maharashtra CMEGP - Service Sector | MSME Business Funding",
      "description": "State credit-linked subsidy up to 35% for new service units."
    },
    "isActive": true,
    "popular": true
  },
  {
    "_id": "tamil-nadu-needs",
    "name": "Tamil Nadu NEEDS Scheme",
    "slug": "tamil-nadu-needs",
    "category": "government",
    "description": "Subsidy of 25% up to Rs. 25 Lakhs for first-generation entrepreneurs in TN.",
    "longDescription": "First-generation entrepreneur. TN Domicile. Degree/Diploma/ITI. Age 21-35.",
    "minAmount": 1000000,
    "maxAmount": 50000000,
    "interestRate": "6.0% - 9.5%",
    "processingTime": "10 - 15 working days",
    "tenure": "Up to 7 years",
    "collateral": false,
    "documents": [
      "Degree Certificate",
      "Aadhaar Card",
      "Project Report",
      "Domicile Certificate"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Apply on",
        "description": "Apply on TN Single Window Portal"
      },
      {
        "step": 2,
        "title": "Submit certificates",
        "description": "Submit certificates and project report"
      },
      {
        "step": 3,
        "title": "District Selection",
        "description": "District Selection interview"
      },
      {
        "step": 4,
        "title": "Bank sanction & release",
        "description": "Bank sanction & release"
      }
    ],
    "features": [
      "Loan amount up to ₹500 Lakh",
      "Attractive interest rate: 6.0% - 9.5%",
      "Zero collateral needed",
      "Quick processing within 10 - 15 working days"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for Tamil Nadu NEEDS Scheme?",
        "answer": "Up to ₹5,00,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "First-generation entrepreneur. TN Domicile. Degree/Diploma/ITI. Age 21-35.",
      "minTurnover": 1000000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "sole proprietor",
        "micro-enterprise"
      ]
    },
    "seo": {
      "title": "Tamil Nadu NEEDS Scheme | MSME Business Funding",
      "description": "Subsidy of 25% up to Rs. 25 Lakhs for first-generation entrepreneurs in TN."
    },
    "isActive": true,
    "popular": true
  },
  {
    "_id": "tamil-nadu-uyegp",
    "name": "Tamil Nadu UYEGP Scheme",
    "slug": "tamil-nadu-uyegp",
    "category": "government",
    "description": "Subsidy up to 25% for projects costing up to Rs. 5 Lakhs for unemployed youth.",
    "longDescription": "Unemployed youth. Age 18-35 (45 for special). Min VIII pass. Income < 5L.",
    "minAmount": 10000,
    "maxAmount": 500000,
    "interestRate": "6.0% - 9.5%",
    "processingTime": "10 - 15 working days",
    "tenure": "Up to 7 years",
    "collateral": false,
    "documents": [
      "Transfer Certificate",
      "Aadhaar Card",
      "Project Profile",
      "Income Certificate"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Register on",
        "description": "Register on TN MSME Online portal"
      },
      {
        "step": 2,
        "title": "Upload project",
        "description": "Upload project profile and income details"
      },
      {
        "step": 3,
        "title": "Task force",
        "description": "Task force interview & bank sanction"
      }
    ],
    "features": [
      "Loan amount up to ₹5 Lakh",
      "Attractive interest rate: 6.0% - 9.5%",
      "Zero collateral needed",
      "Quick processing within 10 - 15 working days"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for Tamil Nadu UYEGP Scheme?",
        "answer": "Up to ₹5,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "Unemployed youth. Age 18-35 (45 for special). Min VIII pass. Income < 5L.",
      "minTurnover": 10000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "sole proprietor",
        "freelancer",
        "micro-enterprise"
      ]
    },
    "seo": {
      "title": "Tamil Nadu UYEGP Scheme | MSME Business Funding",
      "description": "Subsidy up to 25% for projects costing up to Rs. 5 Lakhs for unemployed youth."
    },
    "isActive": true,
    "popular": true
  },
  {
    "_id": "gujarat-mysy",
    "name": "Gujarat MYSY - Business Subsidy",
    "slug": "gujarat-mysy",
    "category": "government",
    "description": "5% interest subsidy and capital subsidy up to 25% (max Rs. 12.5L) in Gujarat.",
    "longDescription": "Gujarat resident. Age 18 to 40 years. Business set up in Gujarat.",
    "minAmount": 100000,
    "maxAmount": 5000000,
    "interestRate": "6.0% - 9.5%",
    "processingTime": "10 - 15 working days",
    "tenure": "Up to 7 years",
    "collateral": false,
    "documents": [
      "Aadhaar Card",
      "Age Proof",
      "Project Report",
      "Domicile Certificate"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Apply online",
        "description": "Apply online on Gujarat IC portal"
      },
      {
        "step": 2,
        "title": "Upload proposed",
        "description": "Upload proposed activity details"
      },
      {
        "step": 3,
        "title": "DIC verifies",
        "description": "DIC verifies and forwards to bank"
      }
    ],
    "features": [
      "Loan amount up to ₹50 Lakh",
      "Attractive interest rate: 6.0% - 9.5%",
      "Zero collateral needed",
      "Quick processing within 10 - 15 working days"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for Gujarat MYSY - Business Subsidy?",
        "answer": "Up to ₹50,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "Gujarat resident. Age 18 to 40 years. Business set up in Gujarat.",
      "minTurnover": 100000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "sole proprietor",
        "freelancer",
        "micro-enterprise"
      ]
    },
    "seo": {
      "title": "Gujarat MYSY - Business Subsidy | MSME Business Funding",
      "description": "5% interest subsidy and capital subsidy up to 25% (max Rs. 12.5L) in Gujarat."
    },
    "isActive": true,
    "popular": true
  },
  {
    "_id": "uttar-pradesh-mysy",
    "name": "Uttar Pradesh MYSY Scheme",
    "slug": "uttar-pradesh-mysy",
    "category": "government",
    "description": "Concessional loans with 25% margin money subsidy for UP youth.",
    "longDescription": "UP domicile. Age 18 to 40. High school (X) pass. No prior default.",
    "minAmount": 50000,
    "maxAmount": 2500000,
    "interestRate": "6.0% - 9.5%",
    "processingTime": "10 - 15 working days",
    "tenure": "Up to 7 years",
    "collateral": false,
    "documents": [
      "High School Certificate",
      "Aadhaar Card",
      "UP Domicile certificate",
      "Project Report"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Apply online",
        "description": "Apply online on UP MSME portal"
      },
      {
        "step": 2,
        "title": "Upload reports",
        "description": "Upload reports and marksheet"
      },
      {
        "step": 3,
        "title": "District Task",
        "description": "District Task Force review & bank sanction"
      }
    ],
    "features": [
      "Loan amount up to ₹25 Lakh",
      "Attractive interest rate: 6.0% - 9.5%",
      "Zero collateral needed",
      "Quick processing within 10 - 15 working days"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for Uttar Pradesh MYSY Scheme?",
        "answer": "Up to ₹25,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "UP domicile. Age 18 to 40. High school (X) pass. No prior default.",
      "minTurnover": 50000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "sole proprietor",
        "micro-enterprise"
      ]
    },
    "seo": {
      "title": "Uttar Pradesh MYSY Scheme | MSME Business Funding",
      "description": "Concessional loans with 25% margin money subsidy for UP youth."
    },
    "isActive": true,
    "popular": true
  },
  {
    "_id": "west-bengal-karmasathi",
    "name": "West Bengal Karma Sathi",
    "slug": "west-bengal-karmasathi",
    "category": "government",
    "description": "Low-interest loans up to Rs. 2 Lakhs at 4% simple interest for unemployed youth in WB.",
    "longDescription": "WB resident. Age 18 to 50 years. Minimum VIII pass. Domiciled.",
    "minAmount": 10000,
    "maxAmount": 200000,
    "interestRate": "6.0% - 9.5%",
    "processingTime": "10 - 15 working days",
    "tenure": "Up to 7 years",
    "collateral": false,
    "documents": [
      "Aadhaar Card",
      "Educational Proof",
      "Residence Proof",
      "Project Brief"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Download form",
        "description": "Download form from Karma Sathi portal"
      },
      {
        "step": 2,
        "title": "Submit to",
        "description": "Submit to local BDO/SDO office"
      },
      {
        "step": 3,
        "title": "Task force",
        "description": "Task force verification & bank credit release"
      }
    ],
    "features": [
      "Loan amount up to ₹2 Lakh",
      "Attractive interest rate: 6.0% - 9.5%",
      "Zero collateral needed",
      "Quick processing within 10 - 15 working days"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for West Bengal Karma Sathi?",
        "answer": "Up to ₹2,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "WB resident. Age 18 to 50 years. Minimum VIII pass. Domiciled.",
      "minTurnover": 10000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "sole proprietor",
        "freelancer",
        "micro-enterprise"
      ]
    },
    "seo": {
      "title": "West Bengal Karma Sathi | MSME Business Funding",
      "description": "Low-interest loans up to Rs. 2 Lakhs at 4% simple interest for unemployed youth in WB."
    },
    "isActive": true,
    "popular": false
  },
  {
    "_id": "kerala-kfc-micro-loan",
    "name": "Kerala KFC Micro Enterprise Loan",
    "slug": "kerala-kfc-micro-loan",
    "category": "government",
    "description": "Collateral-free loans up to Rs. 10 Lakhs for micro units in Kerala.",
    "longDescription": "Active unit in Kerala. Valid Udyam and K-Swift registration.",
    "minAmount": 100000,
    "maxAmount": 1000000,
    "interestRate": "6.0% - 9.5%",
    "processingTime": "10 - 15 working days",
    "tenure": "Up to 7 years",
    "collateral": false,
    "documents": [
      "Aadhaar Card",
      "PAN Card",
      "Udyam Registration",
      "K-Swift Document"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Apply online",
        "description": "Apply online through K-Swift portal"
      },
      {
        "step": 2,
        "title": "Select KFC",
        "description": "Select KFC Micro Enterprise Loan"
      },
      {
        "step": 3,
        "title": "KFC site",
        "description": "KFC site inspection and direct disbursal"
      }
    ],
    "features": [
      "Loan amount up to ₹10 Lakh",
      "Attractive interest rate: 6.0% - 9.5%",
      "Zero collateral needed",
      "Quick processing within 10 - 15 working days"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for Kerala KFC Micro Enterprise Loan?",
        "answer": "Up to ₹10,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "Active unit in Kerala. Valid Udyam and K-Swift registration.",
      "minTurnover": 100000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "sole proprietor",
        "freelancer",
        "micro-enterprise"
      ]
    },
    "seo": {
      "title": "Kerala KFC Micro Enterprise Loan | MSME Business Funding",
      "description": "Collateral-free loans up to Rs. 10 Lakhs for micro units in Kerala."
    },
    "isActive": true,
    "popular": false
  },
  {
    "_id": "kerala-kssedm",
    "name": "Kerala KSSEDM Scheme",
    "slug": "kerala-kssedm",
    "category": "government",
    "description": "Interest-free loans up to Rs. 10 Lakhs to promote entrepreneurship.",
    "longDescription": "Kerala resident. Age 18-40. Unemployed youth with Degree/ITI/Diploma.",
    "minAmount": 50000,
    "maxAmount": 1000000,
    "interestRate": "6.0% - 9.5%",
    "processingTime": "10 - 15 working days",
    "tenure": "Up to 7 years",
    "collateral": false,
    "documents": [
      "Educational certificates",
      "Aadhaar Card",
      "Domicile Certificate",
      "Project Proposal"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Register through",
        "description": "Register through local Employment Exchange"
      },
      {
        "step": 2,
        "title": "Attend entrepreneurship",
        "description": "Attend entrepreneurship training"
      },
      {
        "step": 3,
        "title": "KFC sanction",
        "description": "KFC sanction and disbursal"
      }
    ],
    "features": [
      "Loan amount up to ₹10 Lakh",
      "Attractive interest rate: 6.0% - 9.5%",
      "Zero collateral needed",
      "Quick processing within 10 - 15 working days"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for Kerala KSSEDM Scheme?",
        "answer": "Up to ₹10,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "Kerala resident. Age 18-40. Unemployed youth with Degree/ITI/Diploma.",
      "minTurnover": 50000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "sole proprietor",
        "freelancer"
      ]
    },
    "seo": {
      "title": "Kerala KSSEDM Scheme | MSME Business Funding",
      "description": "Interest-free loans up to Rs. 10 Lakhs to promote entrepreneurship."
    },
    "isActive": true,
    "popular": false
  },
  {
    "_id": "rajasthan-mmysy",
    "name": "Rajasthan MLUPY Scheme",
    "slug": "rajasthan-mmysy",
    "category": "government",
    "description": "Concessional loans with interest subsidies of 5% to 8% for micro and small units.",
    "longDescription": "Rajasthan resident. Age above 18. New or expansion units in manufacturing, service or trade.",
    "minAmount": 100000,
    "maxAmount": 10000000,
    "interestRate": "6.0% - 9.5%",
    "processingTime": "10 - 15 working days",
    "tenure": "Up to 7 years",
    "collateral": false,
    "documents": [
      "Aadhaar Card",
      "PAN Card",
      "Detailed Project Report",
      "Udyam Certificate"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Apply on",
        "description": "Apply on Rajasthan Single Window"
      },
      {
        "step": 2,
        "title": "Submit form",
        "description": "Submit form and choose bank branch"
      },
      {
        "step": 3,
        "title": "DIC processes",
        "description": "DIC processes and bank disburses"
      }
    ],
    "features": [
      "Loan amount up to ₹100 Lakh",
      "Attractive interest rate: 6.0% - 9.5%",
      "Zero collateral needed",
      "Quick processing within 10 - 15 working days"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for Rajasthan MLUPY Scheme?",
        "answer": "Up to ₹1,00,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "Rajasthan resident. Age above 18. New or expansion units in manufacturing, service or trade.",
      "minTurnover": 100000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "sole proprietor",
        "micro-enterprise"
      ]
    },
    "seo": {
      "title": "Rajasthan MLUPY Scheme | MSME Business Funding",
      "description": "Concessional loans with interest subsidies of 5% to 8% for micro and small units."
    },
    "isActive": true,
    "popular": true
  },
  {
    "_id": "karnataka-cmsry",
    "name": "Karnataka CMSRY Scheme",
    "slug": "karnataka-cmsry",
    "category": "government",
    "description": "Chief Minister’s Self Employment Generation Programme offering financial assistance and subsidy up to 35% for rural and urban entrepreneurs.",
    "longDescription": "Karnataka resident. Age 18-45. Minimum qualification 8th standard pass for project sizes over Rs. 10 Lakhs.",
    "minAmount": 100000,
    "maxAmount": 2500000,
    "interestRate": "6.0% - 9.5%",
    "processingTime": "10 - 15 working days",
    "tenure": "Up to 7 years",
    "collateral": false,
    "documents": [
      "Domicile Certificate",
      "Aadhaar Card",
      "Educational qualification proof",
      "Detailed Project Report (DPR)",
      "Caste/Category certificate (if applicable)"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Register and",
        "description": "Register and apply online on DIC Karnataka portal"
      },
      {
        "step": 2,
        "title": "Submit physical",
        "description": "Submit physical documents to District Industries Centre (DIC)"
      },
      {
        "step": 3,
        "title": "Screening committee",
        "description": "Screening committee interview and recommendation to bank"
      },
      {
        "step": 4,
        "title": "Bank sanction",
        "description": "Bank sanction and subsidy release"
      }
    ],
    "features": [
      "Loan amount up to ₹25 Lakh",
      "Attractive interest rate: 6.0% - 9.5%",
      "Zero collateral needed",
      "Quick processing within 10 - 15 working days"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for Karnataka CMSRY Scheme?",
        "answer": "Up to ₹25,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "Karnataka resident. Age 18-45. Minimum qualification 8th standard pass for project sizes over Rs. 10 Lakhs.",
      "minTurnover": 100000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "sole proprietor",
        "partnership-firm",
        "micro-enterprise"
      ]
    },
    "seo": {
      "title": "Karnataka CMSRY Scheme | MSME Business Funding",
      "description": "Chief Minister’s Self Employment Generation Programme offering financial assistance and subsidy up to 35% for rural and urban entrepreneurs."
    },
    "isActive": true,
    "popular": true
  },
  {
    "_id": "sbi-professional-loan",
    "name": "SBI Loan for Professionals",
    "slug": "sbi-professional-loan",
    "category": "bank",
    "description": "Unsecured credit up to Rs. 50 Lakhs for doctors, CAs, and architects.",
    "longDescription": "Qualified professionals. Minimum 3 years practice. ITR (2 years). CIBIL >= 700.",
    "minAmount": 100000,
    "maxAmount": 5000000,
    "interestRate": "8.5% - 13.0%",
    "processingTime": "3 - 7 working days",
    "tenure": "1 to 5 years",
    "collateral": false,
    "documents": [
      "Degree Certificate",
      "Practice Certificate",
      "ITR (2 years)",
      "6 Months Bank Statements"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Apply on SBI loan portal",
        "description": "Apply on SBI loan portal"
      },
      {
        "step": 2,
        "title": "Submit professional",
        "description": "Submit professional credentials & ITR"
      },
      {
        "step": 3,
        "title": "Credit appraisal",
        "description": "Credit appraisal & disbursal"
      }
    ],
    "features": [
      "Loan amount up to ₹50 Lakh",
      "Attractive interest rate: 8.5% - 13.0%",
      "Zero collateral needed",
      "Quick processing within 3 - 7 working days"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for SBI Loan for Professionals?",
        "answer": "Up to ₹50,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "Qualified professionals. Minimum 3 years practice. ITR (2 years). CIBIL >= 700.",
      "minTurnover": 100000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "sole proprietor",
        "freelancer"
      ]
    },
    "seo": {
      "title": "SBI Loan for Professionals | MSME Business Funding",
      "description": "Unsecured credit up to Rs. 50 Lakhs for doctors, CAs, and architects."
    },
    "isActive": true,
    "popular": false
  },
  {
    "_id": "pnb-professional-loan",
    "name": "PNB Loan for Professionals",
    "slug": "pnb-professional-loan",
    "category": "bank",
    "description": "Unsecured term credit up to Rs. 40 Lakhs for practicing professionals.",
    "longDescription": "Doctor, CA, Architect. 3 years vintage. Income tax filer. CIBIL >= 700.",
    "minAmount": 100000,
    "maxAmount": 4000000,
    "interestRate": "8.5% - 13.0%",
    "processingTime": "3 - 7 working days",
    "tenure": "1 to 5 years",
    "collateral": false,
    "documents": [
      "Degree Certificate",
      "Practice Proof",
      "6 Months Bank Statement",
      "2 Years ITR"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Apply on",
        "description": "Apply on PNB corporate portal"
      },
      {
        "step": 2,
        "title": "Verify credentials",
        "description": "Verify credentials and income returns"
      },
      {
        "step": 3,
        "title": "PNB branch",
        "description": "PNB branch credit sanction"
      }
    ],
    "features": [
      "Loan amount up to ₹40 Lakh",
      "Attractive interest rate: 8.5% - 13.0%",
      "Zero collateral needed",
      "Quick processing within 3 - 7 working days"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for PNB Loan for Professionals?",
        "answer": "Up to ₹40,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "Doctor, CA, Architect. 3 years vintage. Income tax filer. CIBIL >= 700.",
      "minTurnover": 100000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "sole proprietor",
        "freelancer"
      ]
    },
    "seo": {
      "title": "PNB Loan for Professionals | MSME Business Funding",
      "description": "Unsecured term credit up to Rs. 40 Lakhs for practicing professionals."
    },
    "isActive": true,
    "popular": false
  },
  {
    "_id": "bob-professional-loan",
    "name": "BoB Loan for Professionals",
    "slug": "bob-professional-loan",
    "category": "bank",
    "description": "Unsecured credit up to Rs. 25 Lakhs for practitioners.",
    "longDescription": "Practicing professional with min 3 years vintage. Age 25-65.",
    "minAmount": 100000,
    "maxAmount": 2500000,
    "interestRate": "8.5% - 13.0%",
    "processingTime": "3 - 7 working days",
    "tenure": "1 to 5 years",
    "collateral": false,
    "documents": [
      "PAN Card",
      "Aadhaar Card",
      "Degree Certificate",
      "ITR of 2 years"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Visit BOB online portal",
        "description": "Visit BOB online portal"
      },
      {
        "step": 2,
        "title": "Select professional",
        "description": "Select professional loan & upload documents"
      },
      {
        "step": 3,
        "title": "Underwriting and",
        "description": "Underwriting and disbursal"
      }
    ],
    "features": [
      "Loan amount up to ₹25 Lakh",
      "Attractive interest rate: 8.5% - 13.0%",
      "Zero collateral needed",
      "Quick processing within 3 - 7 working days"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for BoB Loan for Professionals?",
        "answer": "Up to ₹25,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "Practicing professional with min 3 years vintage. Age 25-65.",
      "minTurnover": 100000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "sole proprietor",
        "freelancer"
      ]
    },
    "seo": {
      "title": "BoB Loan for Professionals | MSME Business Funding",
      "description": "Unsecured credit up to Rs. 25 Lakhs for practitioners."
    },
    "isActive": true,
    "popular": false
  },
  {
    "_id": "canara-professional-loan",
    "name": "Canara Professional Loan",
    "slug": "canara-professional-loan",
    "category": "bank",
    "description": "Unsecured term loan up to Rs. 35 Lakhs for practicing professionals.",
    "longDescription": "Professionals with min 3 years practice. CIBIL score above 720.",
    "minAmount": 50000,
    "maxAmount": 3500000,
    "interestRate": "8.5% - 13.0%",
    "processingTime": "3 - 7 working days",
    "tenure": "1 to 5 years",
    "collateral": false,
    "documents": [
      "Degree credentials",
      "PAN and Aadhaar",
      "ITR for past 2 years"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Submit application",
        "description": "Submit application on Canara portal"
      },
      {
        "step": 2,
        "title": "Upload financials",
        "description": "Upload financials and credentials"
      },
      {
        "step": 3,
        "title": "Credit check",
        "description": "Credit check and limit release"
      }
    ],
    "features": [
      "Loan amount up to ₹35 Lakh",
      "Attractive interest rate: 8.5% - 13.0%",
      "Zero collateral needed",
      "Quick processing within 3 - 7 working days"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for Canara Professional Loan?",
        "answer": "Up to ₹35,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "Professionals with min 3 years practice. CIBIL score above 720.",
      "minTurnover": 50000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "sole proprietor",
        "freelancer"
      ]
    },
    "seo": {
      "title": "Canara Professional Loan | MSME Business Funding",
      "description": "Unsecured term loan up to Rs. 35 Lakhs for practicing professionals."
    },
    "isActive": true,
    "popular": false
  },
  {
    "_id": "union-professional-loan",
    "name": "Union Bank Professional Loan",
    "slug": "union-professional-loan",
    "category": "bank",
    "description": "Unsecured business loan up to Rs. 50 Lakhs for practice setup.",
    "longDescription": "Doctor, CA, CS, architect running active practice for 3 years.",
    "minAmount": 100000,
    "maxAmount": 5000000,
    "interestRate": "8.5% - 13.0%",
    "processingTime": "3 - 7 working days",
    "tenure": "1 to 5 years",
    "collateral": false,
    "documents": [
      "Degree Certificate",
      "Registration Certificate",
      "2 Years ITR",
      "Bank statements"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Apply online",
        "description": "Apply online on Union Bank portal"
      },
      {
        "step": 2,
        "title": "Upload professional",
        "description": "Upload professional registry and financials"
      },
      {
        "step": 3,
        "title": "Sanction and",
        "description": "Sanction and branch release"
      }
    ],
    "features": [
      "Loan amount up to ₹50 Lakh",
      "Attractive interest rate: 8.5% - 13.0%",
      "Zero collateral needed",
      "Quick processing within 3 - 7 working days"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for Union Bank Professional Loan?",
        "answer": "Up to ₹50,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "Doctor, CA, CS, architect running active practice for 3 years.",
      "minTurnover": 100000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "sole proprietor",
        "freelancer"
      ]
    },
    "seo": {
      "title": "Union Bank Professional Loan | MSME Business Funding",
      "description": "Unsecured business loan up to Rs. 50 Lakhs for practice setup."
    },
    "isActive": true,
    "popular": false
  },
  {
    "_id": "indian-bank-professional-loan",
    "name": "Indian Bank Ind Professional",
    "slug": "indian-bank-professional-loan",
    "category": "bank",
    "description": "Unsecured business development loan up to Rs. 25 Lakhs.",
    "longDescription": "Doctor, CA or CS with 3 years active practice. CIBIL score 700+.",
    "minAmount": 100000,
    "maxAmount": 2500000,
    "interestRate": "8.5% - 13.0%",
    "processingTime": "3 - 7 working days",
    "tenure": "1 to 5 years",
    "collateral": false,
    "documents": [
      "Degree Certificate",
      "ITR returns",
      "6 months bank statement"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Submit application",
        "description": "Submit application on Indian Bank portal"
      },
      {
        "step": 2,
        "title": "Select Ind",
        "description": "Select Ind Professional scheme & upload details"
      },
      {
        "step": 3,
        "title": "Appraisal & disbursal",
        "description": "Appraisal & disbursal"
      }
    ],
    "features": [
      "Loan amount up to ₹25 Lakh",
      "Attractive interest rate: 8.5% - 13.0%",
      "Zero collateral needed",
      "Quick processing within 3 - 7 working days"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for Indian Bank Ind Professional?",
        "answer": "Up to ₹25,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "Doctor, CA or CS with 3 years active practice. CIBIL score 700+.",
      "minTurnover": 100000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "sole proprietor",
        "freelancer"
      ]
    },
    "seo": {
      "title": "Indian Bank Ind Professional | MSME Business Funding",
      "description": "Unsecured business development loan up to Rs. 25 Lakhs."
    },
    "isActive": true,
    "popular": false
  },
  {
    "_id": "sbi-e-overdraft-gst",
    "name": "SBI e-Overdraft against GST",
    "slug": "sbi-e-overdraft-gst",
    "category": "bank",
    "description": "Revolving digital overdraft facility up to Rs. 5 Lakhs based on GST data.",
    "longDescription": "GST returns filed for minimum 12 months. Current account vintage with SBI.",
    "minAmount": 50000,
    "maxAmount": 500000,
    "interestRate": "9.5% - 11.0%",
    "processingTime": "3 - 7 working days",
    "tenure": "1 to 5 years",
    "collateral": false,
    "documents": [
      "GST returns (12 months)",
      "PAN Card",
      "SBI Account Details"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Login to SBI net banking",
        "description": "Login to SBI net banking"
      },
      {
        "step": 2,
        "title": "Authenticate GST",
        "description": "Authenticate GST data & fetch returns"
      },
      {
        "step": 3,
        "title": "E-sign digital",
        "description": "E-sign digital agreement & setup line"
      }
    ],
    "features": [
      "Loan amount up to ₹5 Lakh",
      "Attractive interest rate: 9.5% - 11.0%",
      "Zero collateral needed",
      "Quick processing within 3 - 7 working days"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for SBI e-Overdraft against GST?",
        "answer": "Up to ₹5,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "GST returns filed for minimum 12 months. Current account vintage with SBI.",
      "minTurnover": 50000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "sole proprietor",
        "micro-enterprise"
      ]
    },
    "seo": {
      "title": "SBI e-Overdraft against GST | MSME Business Funding",
      "description": "Revolving digital overdraft facility up to Rs. 5 Lakhs based on GST data."
    },
    "isActive": true,
    "popular": false
  },
  {
    "_id": "pnb-gst-sahay-od",
    "name": "PNB GST Sahay OD",
    "slug": "pnb-gst-sahay-od",
    "category": "bank",
    "description": "Instant digital working capital overdraft up to Rs. 5 Lakhs linked to GST.",
    "longDescription": "At least 1 year GST registration. Automatic system evaluation.",
    "minAmount": 10000,
    "maxAmount": 500000,
    "interestRate": "9.5% - 11.0%",
    "processingTime": "3 - 7 working days",
    "tenure": "1 to 5 years",
    "collateral": false,
    "documents": [
      "GST credentials",
      "Business PAN",
      "Aadhaar Card"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Register on",
        "description": "Register on PNB GST Sahay portal"
      },
      {
        "step": 2,
        "title": "Authenticate using",
        "description": "Authenticate using GSTIN & Aadhaar OTP"
      },
      {
        "step": 3,
        "title": "Invoice mapping",
        "description": "Invoice mapping and instant line setup"
      }
    ],
    "features": [
      "Loan amount up to ₹5 Lakh",
      "Attractive interest rate: 9.5% - 11.0%",
      "Zero collateral needed",
      "Quick processing within 3 - 7 working days"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for PNB GST Sahay OD?",
        "answer": "Up to ₹5,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "At least 1 year GST registration. Automatic system evaluation.",
      "minTurnover": 10000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "sole proprietor",
        "micro-enterprise"
      ]
    },
    "seo": {
      "title": "PNB GST Sahay OD | MSME Business Funding",
      "description": "Instant digital working capital overdraft up to Rs. 5 Lakhs linked to GST."
    },
    "isActive": true,
    "popular": false
  },
  {
    "_id": "bob-cash-credit",
    "name": "BoB Unsecured Cash Credit",
    "slug": "bob-cash-credit",
    "category": "bank",
    "description": "Unsecured working capital cash credit limits up to Rs. 10 Lakhs under CGTMSE.",
    "longDescription": "Existing trade business. Min 2 years vintage. Udyam registered.",
    "minAmount": 100000,
    "maxAmount": 1000000,
    "interestRate": "8.5% - 13.0%",
    "processingTime": "3 - 7 working days",
    "tenure": "1 to 5 years",
    "collateral": false,
    "documents": [
      "Udyam Certificate",
      "6 Months Bank Statements",
      "PAN Card",
      "GST Returns"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Apply online",
        "description": "Apply online on BOB portal"
      },
      {
        "step": 2,
        "title": "Provide statements",
        "description": "Provide statements and request CGTMSE cover"
      },
      {
        "step": 3,
        "title": "Bank verifies",
        "description": "Bank verifies & sanctions limit"
      }
    ],
    "features": [
      "Loan amount up to ₹10 Lakh",
      "Attractive interest rate: 8.5% - 13.0%",
      "Zero collateral needed",
      "Quick processing within 3 - 7 working days"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for BoB Unsecured Cash Credit?",
        "answer": "Up to ₹10,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "Existing trade business. Min 2 years vintage. Udyam registered.",
      "minTurnover": 100000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "sole proprietor",
        "micro-enterprise"
      ]
    },
    "seo": {
      "title": "BoB Unsecured Cash Credit | MSME Business Funding",
      "description": "Unsecured working capital cash credit limits up to Rs. 10 Lakhs under CGTMSE."
    },
    "isActive": true,
    "popular": false
  },
  {
    "_id": "psb-loans-59-minutes-portal",
    "name": "PSB Loans in 59 Minutes",
    "slug": "psb-loans-59-minutes-portal",
    "category": "bank",
    "description": "In-principle approval of MSME business loans up to Rs. 5 Crore in under an hour.",
    "longDescription": "Valid GST, ITR (1-3 years), and bank statements.",
    "minAmount": 100000,
    "maxAmount": 50000000,
    "interestRate": "8.5% - 13.0%",
    "processingTime": "3 - 7 working days",
    "tenure": "1 to 5 years",
    "collateral": false,
    "documents": [
      "GST Credentials",
      "ITR XML Files",
      "6 Months Bank Statement"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Register on",
        "description": "Register on PSB Loans 59 portal"
      },
      {
        "step": 2,
        "title": "Upload GST,",
        "description": "Upload GST, ITR, and bank records"
      },
      {
        "step": 3,
        "title": "Digital in-principle",
        "description": "Digital in-principle approval generation"
      },
      {
        "step": 4,
        "title": "Branch visit",
        "description": "Branch visit for disbursal"
      }
    ],
    "features": [
      "Loan amount up to ₹500 Lakh",
      "Attractive interest rate: 8.5% - 13.0%",
      "Zero collateral needed",
      "Quick processing within 3 - 7 working days"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for PSB Loans in 59 Minutes?",
        "answer": "Up to ₹5,00,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "Valid GST, ITR (1-3 years), and bank statements.",
      "minTurnover": 100000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "sole proprietor",
        "micro-enterprise",
        "partnership"
      ]
    },
    "seo": {
      "title": "PSB Loans in 59 Minutes | MSME Business Funding",
      "description": "In-principle approval of MSME business loans up to Rs. 5 Crore in under an hour."
    },
    "isActive": true,
    "popular": false
  },
  {
    "_id": "hdfc-professional-loan",
    "name": "HDFC Bank Professional Loan",
    "slug": "hdfc-professional-loan",
    "category": "bank",
    "description": "Unsecured business loans up to Rs. 75 Lakhs for professionals.",
    "longDescription": "Doctor, CA, CS, architect. 3+ years practice. CIBIL >= 700.",
    "minAmount": 100000,
    "maxAmount": 7500000,
    "interestRate": "8.5% - 13.0%",
    "processingTime": "3 - 7 working days",
    "tenure": "1 to 5 years",
    "collateral": false,
    "documents": [
      "Professional Certificate",
      "2 Years ITR files",
      "Bank Statement via Perfios"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Apply on HDFC loan portal",
        "description": "Apply on HDFC loan portal"
      },
      {
        "step": 2,
        "title": "Submit bank",
        "description": "Submit bank data via Perfios consent"
      },
      {
        "step": 3,
        "title": "Appraisal & disbursal",
        "description": "Appraisal & disbursal"
      }
    ],
    "features": [
      "Loan amount up to ₹75 Lakh",
      "Attractive interest rate: 8.5% - 13.0%",
      "Zero collateral needed",
      "Quick processing within 3 - 7 working days"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for HDFC Bank Professional Loan?",
        "answer": "Up to ₹75,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "Doctor, CA, CS, architect. 3+ years practice. CIBIL >= 700.",
      "minTurnover": 100000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "sole proprietor",
        "freelancer"
      ]
    },
    "seo": {
      "title": "HDFC Bank Professional Loan | MSME Business Funding",
      "description": "Unsecured business loans up to Rs. 75 Lakhs for professionals."
    },
    "isActive": true,
    "popular": false
  },
  {
    "_id": "icici-professional-loan",
    "name": "ICICI Bank Professional Loan",
    "slug": "icici-professional-loan",
    "category": "bank",
    "description": "Digital unsecured loans up to Rs. 50 Lakhs for doctors, CAs.",
    "longDescription": "Doctor or CA. Minimum age 25. 3 years practice.",
    "minAmount": 100000,
    "maxAmount": 5000000,
    "interestRate": "8.5% - 13.0%",
    "processingTime": "3 - 7 working days",
    "tenure": "1 to 5 years",
    "collateral": false,
    "documents": [
      "Degree Certificate",
      "Bank Statement",
      "2 Years ITR"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Visit ICICI",
        "description": "Visit ICICI Instabiz portal"
      },
      {
        "step": 2,
        "title": "Provide statements",
        "description": "Provide statements via Account Aggregator"
      },
      {
        "step": 3,
        "title": "E-sign agreement",
        "description": "E-sign agreement and disbursal"
      }
    ],
    "features": [
      "Loan amount up to ₹50 Lakh",
      "Attractive interest rate: 8.5% - 13.0%",
      "Zero collateral needed",
      "Quick processing within 3 - 7 working days"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for ICICI Bank Professional Loan?",
        "answer": "Up to ₹50,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "Doctor or CA. Minimum age 25. 3 years practice.",
      "minTurnover": 100000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "sole proprietor",
        "freelancer"
      ]
    },
    "seo": {
      "title": "ICICI Bank Professional Loan | MSME Business Funding",
      "description": "Digital unsecured loans up to Rs. 50 Lakhs for doctors, CAs."
    },
    "isActive": true,
    "popular": false
  },
  {
    "_id": "axis-professional-power",
    "name": "Axis Professional Power",
    "slug": "axis-professional-power",
    "category": "bank",
    "description": "Unsecured loans up to Rs. 75 Lakhs for doctors and professionals.",
    "longDescription": "Minimum 3 years practice experience. Max age 65.",
    "minAmount": 100000,
    "maxAmount": 7500000,
    "interestRate": "8.5% - 13.0%",
    "processingTime": "3 - 7 working days",
    "tenure": "1 to 5 years",
    "collateral": false,
    "documents": [
      "Degree Certificate",
      "12 Months bank statements",
      "ITR returns"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Apply via",
        "description": "Apply via Axis mobile app or site"
      },
      {
        "step": 2,
        "title": "Upload income",
        "description": "Upload income returns & bank statement PDF"
      },
      {
        "step": 3,
        "title": "E-mandate signature",
        "description": "E-mandate signature and disbursal"
      }
    ],
    "features": [
      "Loan amount up to ₹75 Lakh",
      "Attractive interest rate: 8.5% - 13.0%",
      "Zero collateral needed",
      "Quick processing within 3 - 7 working days"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for Axis Professional Power?",
        "answer": "Up to ₹75,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "Minimum 3 years practice experience. Max age 65.",
      "minTurnover": 100000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "sole proprietor",
        "freelancer"
      ]
    },
    "seo": {
      "title": "Axis Professional Power | MSME Business Funding",
      "description": "Unsecured loans up to Rs. 75 Lakhs for doctors and professionals."
    },
    "isActive": true,
    "popular": false
  },
  {
    "_id": "bajaj-finserv-professional-loan",
    "name": "Bajaj Finserv Professional Loan",
    "slug": "bajaj-finserv-professional-loan",
    "category": "bank",
    "description": "High-ticket unsecured loans up to Rs. 80 Lakhs with same-day disbursal.",
    "longDescription": "Doctor or CA. Min 3 years practice. CIBIL >= 730.",
    "minAmount": 200000,
    "maxAmount": 8000000,
    "interestRate": "8.5% - 13.0%",
    "processingTime": "3 - 7 working days",
    "tenure": "1 to 5 years",
    "collateral": false,
    "documents": [
      "Degree Certificate",
      "COA proof",
      "Last 6 Months Bank Statement"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Apply on",
        "description": "Apply on Bajaj Finserv portal"
      },
      {
        "step": 2,
        "title": "Link bank",
        "description": "Link bank account via Netbanking/Perfios"
      },
      {
        "step": 3,
        "title": "E-sign &",
        "description": "E-sign & receive funds in 24 hrs"
      }
    ],
    "features": [
      "Loan amount up to ₹80 Lakh",
      "Attractive interest rate: 8.5% - 13.0%",
      "Zero collateral needed",
      "Quick processing within 3 - 7 working days"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for Bajaj Finserv Professional Loan?",
        "answer": "Up to ₹80,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "Doctor or CA. Min 3 years practice. CIBIL >= 730.",
      "minTurnover": 200000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "sole proprietor",
        "freelancer"
      ]
    },
    "seo": {
      "title": "Bajaj Finserv Professional Loan | MSME Business Funding",
      "description": "High-ticket unsecured loans up to Rs. 80 Lakhs with same-day disbursal."
    },
    "isActive": true,
    "popular": false
  },
  {
    "_id": "hdfc-business-on-click",
    "name": "HDFC Business Loan on Click",
    "slug": "hdfc-business-on-click",
    "category": "bank",
    "description": "Digital business loan up to Rs. 25 Lakhs sanctioned instantly based on GST.",
    "longDescription": "MSME filing GST for 1 year. Minimal credit default history.",
    "minAmount": 100000,
    "maxAmount": 2500000,
    "interestRate": "8.5% - 13.0%",
    "processingTime": "3 - 7 working days",
    "tenure": "1 to 5 years",
    "collateral": false,
    "documents": [
      "GST Return Details",
      "Business PAN",
      "Aadhaar Card"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Visit HDFC Click portal",
        "description": "Visit HDFC Click portal"
      },
      {
        "step": 2,
        "title": "Authenticate using GSTIN",
        "description": "Authenticate using GSTIN"
      },
      {
        "step": 3,
        "title": "Digital evaluation",
        "description": "Digital evaluation and current account credit"
      }
    ],
    "features": [
      "Loan amount up to ₹25 Lakh",
      "Attractive interest rate: 8.5% - 13.0%",
      "Zero collateral needed",
      "Quick processing within 3 - 7 working days"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for HDFC Business Loan on Click?",
        "answer": "Up to ₹25,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "MSME filing GST for 1 year. Minimal credit default history.",
      "minTurnover": 100000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "sole proprietor",
        "micro-enterprise"
      ]
    },
    "seo": {
      "title": "HDFC Business Loan on Click | MSME Business Funding",
      "description": "Digital business loan up to Rs. 25 Lakhs sanctioned instantly based on GST."
    },
    "isActive": true,
    "popular": false
  },
  {
    "_id": "icici-gst-business-loan",
    "name": "ICICI GST Business Loan",
    "slug": "icici-gst-business-loan",
    "category": "bank",
    "description": "Digital working capital limits up to Rs. 25 Lakhs via GST returns.",
    "longDescription": "Minimum 12 months GST returns. Direct digital bank check.",
    "minAmount": 100000,
    "maxAmount": 2500000,
    "interestRate": "8.5% - 13.0%",
    "processingTime": "3 - 7 working days",
    "tenure": "1 to 5 years",
    "collateral": false,
    "documents": [
      "GSTIN credentials",
      "PAN Card",
      "Aadhaar Card"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Apply via ICICI Instabiz",
        "description": "Apply via ICICI Instabiz"
      },
      {
        "step": 2,
        "title": "Authenticate GST",
        "description": "Authenticate GST credentials"
      },
      {
        "step": 3,
        "title": "E-sign and",
        "description": "E-sign and instant limit setup"
      }
    ],
    "features": [
      "Loan amount up to ₹25 Lakh",
      "Attractive interest rate: 8.5% - 13.0%",
      "Zero collateral needed",
      "Quick processing within 3 - 7 working days"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for ICICI GST Business Loan?",
        "answer": "Up to ₹25,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "Minimum 12 months GST returns. Direct digital bank check.",
      "minTurnover": 100000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "sole proprietor",
        "micro-enterprise"
      ]
    },
    "seo": {
      "title": "ICICI GST Business Loan | MSME Business Funding",
      "description": "Digital working capital limits up to Rs. 25 Lakhs via GST returns."
    },
    "isActive": true,
    "popular": false
  },
  {
    "_id": "hdfc-smarthub-merchant",
    "name": "HDFC SmartHub Merchant Loan",
    "slug": "hdfc-smarthub-merchant",
    "category": "bank",
    "description": "POS settlement-linked business loan up to Rs. 15 Lakhs.",
    "longDescription": "HDFC POS merchant. Minimum 6 months swipe history.",
    "minAmount": 50000,
    "maxAmount": 1500000,
    "interestRate": "8.5% - 13.0%",
    "processingTime": "3 - 7 working days",
    "tenure": "1 to 5 years",
    "collateral": false,
    "documents": [
      "SmartHub ID",
      "PAN Card",
      "6 Months settlement records"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Apply on",
        "description": "Apply on SmartHub Merchant app"
      },
      {
        "step": 2,
        "title": "Check pre-approved",
        "description": "Check pre-approved offer and complete e-KYC"
      },
      {
        "step": 3,
        "title": "Disbursal to",
        "description": "Disbursal to current account"
      }
    ],
    "features": [
      "Loan amount up to ₹15 Lakh",
      "Attractive interest rate: 8.5% - 13.0%",
      "Zero collateral needed",
      "Quick processing within 3 - 7 working days"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for HDFC SmartHub Merchant Loan?",
        "answer": "Up to ₹15,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "HDFC POS merchant. Minimum 6 months swipe history.",
      "minTurnover": 50000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "sole proprietor",
        "micro-enterprise"
      ]
    },
    "seo": {
      "title": "HDFC SmartHub Merchant Loan | MSME Business Funding",
      "description": "POS settlement-linked business loan up to Rs. 15 Lakhs."
    },
    "isActive": true,
    "popular": false
  },
  {
    "_id": "icici-merchant-cash-advance",
    "name": "ICICI Merchant Cash Advance",
    "slug": "icici-merchant-cash-advance",
    "category": "bank",
    "description": "Unsecured credit line up to Rs. 10 Lakhs backed by POS swipe transactions.",
    "longDescription": "ICICI POS terminal operator for >6 months. Volume > 50k/mo.",
    "minAmount": 50000,
    "maxAmount": 1000000,
    "interestRate": "8.5% - 13.0%",
    "processingTime": "3 - 7 working days",
    "tenure": "1 to 5 years",
    "collateral": false,
    "documents": [
      "POS Statements",
      "PAN Card",
      "Aadhaar"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Open Instabiz app",
        "description": "Open Instabiz app"
      },
      {
        "step": 2,
        "title": "Select pre-approved",
        "description": "Select pre-approved merchant advance"
      },
      {
        "step": 3,
        "title": "E-sign agreement",
        "description": "E-sign agreement and receive credit"
      }
    ],
    "features": [
      "Loan amount up to ₹10 Lakh",
      "Attractive interest rate: 8.5% - 13.0%",
      "Zero collateral needed",
      "Quick processing within 3 - 7 working days"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for ICICI Merchant Cash Advance?",
        "answer": "Up to ₹10,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "ICICI POS terminal operator for >6 months. Volume > 50k/mo.",
      "minTurnover": 50000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "sole proprietor",
        "micro-enterprise"
      ]
    },
    "seo": {
      "title": "ICICI Merchant Cash Advance | MSME Business Funding",
      "description": "Unsecured credit line up to Rs. 10 Lakhs backed by POS swipe transactions."
    },
    "isActive": true,
    "popular": false
  },
  {
    "_id": "kotak-business-loan",
    "name": "Kotak Business Loan",
    "slug": "kotak-business-loan",
    "category": "bank",
    "description": "Unsecured business loan up to Rs. 30 Lakhs for micro-enterprises.",
    "longDescription": "Minimum 2 years business vintage. ITR for last 2 years. CIBIL >= 700.",
    "minAmount": 100000,
    "maxAmount": 3000000,
    "interestRate": "8.5% - 13.0%",
    "processingTime": "3 - 7 working days",
    "tenure": "1 to 5 years",
    "collateral": false,
    "documents": [
      "PAN Card",
      "Aadhaar Card",
      "2 Years ITR files",
      "6 Months Bank Statements"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Apply on Kotak portal",
        "description": "Apply on Kotak portal"
      },
      {
        "step": 2,
        "title": "Upload financials",
        "description": "Upload financials & bank logs"
      },
      {
        "step": 3,
        "title": "Verification call",
        "description": "Verification call & E-mandate check"
      },
      {
        "step": 4,
        "title": "Loan disbursal",
        "description": "Loan disbursal"
      }
    ],
    "features": [
      "Loan amount up to ₹30 Lakh",
      "Attractive interest rate: 8.5% - 13.0%",
      "Zero collateral needed",
      "Quick processing within 3 - 7 working days"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for Kotak Business Loan?",
        "answer": "Up to ₹30,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "Minimum 2 years business vintage. ITR for last 2 years. CIBIL >= 700.",
      "minTurnover": 100000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "sole proprietor",
        "micro-enterprise"
      ]
    },
    "seo": {
      "title": "Kotak Business Loan | MSME Business Funding",
      "description": "Unsecured business loan up to Rs. 30 Lakhs for micro-enterprises."
    },
    "isActive": true,
    "popular": false
  },
  {
    "_id": "yes-bank-gst-loan",
    "name": "Yes Bank GST Business Loan",
    "slug": "yes-bank-gst-loan",
    "category": "bank",
    "description": "GST-linked working capital term loan up to Rs. 25 Lakhs for trade MSMEs.",
    "longDescription": "MSME with at least 1 year GST returns. Average balance check.",
    "minAmount": 100000,
    "maxAmount": 2500000,
    "interestRate": "8.5% - 13.0%",
    "processingTime": "3 - 7 working days",
    "tenure": "1 to 5 years",
    "collateral": false,
    "documents": [
      "GST returns (12 months)",
      "PAN and Aadhaar",
      "6 Months Bank Statement"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Apply on",
        "description": "Apply on Yes Bank digital portal"
      },
      {
        "step": 2,
        "title": "Share GST",
        "description": "Share GST credentials for check"
      },
      {
        "step": 3,
        "title": "Automated system",
        "description": "Automated system sanction & disbursal"
      }
    ],
    "features": [
      "Loan amount up to ₹25 Lakh",
      "Attractive interest rate: 8.5% - 13.0%",
      "Zero collateral needed",
      "Quick processing within 3 - 7 working days"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for Yes Bank GST Business Loan?",
        "answer": "Up to ₹25,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "MSME with at least 1 year GST returns. Average balance check.",
      "minTurnover": 100000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "sole proprietor",
        "micro-enterprise"
      ]
    },
    "seo": {
      "title": "Yes Bank GST Business Loan | MSME Business Funding",
      "description": "GST-linked working capital term loan up to Rs. 25 Lakhs for trade MSMEs."
    },
    "isActive": true,
    "popular": false
  },
  {
    "_id": "indusind-business-loan",
    "name": "IndusInd Business Loan",
    "slug": "indusind-business-loan",
    "category": "bank",
    "description": "Unsecured business loans up to Rs. 20 Lakhs with minimum paperwork.",
    "longDescription": "Business with regular deposits. Vintage of 24 months.",
    "minAmount": 100000,
    "maxAmount": 2000000,
    "interestRate": "8.5% - 13.0%",
    "processingTime": "3 - 7 working days",
    "tenure": "1 to 5 years",
    "collateral": false,
    "documents": [
      "Aadhaar Card",
      "PAN Card",
      "6 Months Bank statement"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Apply via IndusInd portal",
        "description": "Apply via IndusInd portal"
      },
      {
        "step": 2,
        "title": "Link bank",
        "description": "Link bank account digitally"
      },
      {
        "step": 3,
        "title": "Underwriting check",
        "description": "Underwriting check & disbursal"
      }
    ],
    "features": [
      "Loan amount up to ₹20 Lakh",
      "Attractive interest rate: 8.5% - 13.0%",
      "Zero collateral needed",
      "Quick processing within 3 - 7 working days"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for IndusInd Business Loan?",
        "answer": "Up to ₹20,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "Business with regular deposits. Vintage of 24 months.",
      "minTurnover": 100000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "sole proprietor",
        "freelancer",
        "micro-enterprise"
      ]
    },
    "seo": {
      "title": "IndusInd Business Loan | MSME Business Funding",
      "description": "Unsecured business loans up to Rs. 20 Lakhs with minimum paperwork."
    },
    "isActive": true,
    "popular": false
  },
  {
    "_id": "idfc-first-business-loan",
    "name": "IDFC First Business Loan",
    "slug": "idfc-first-business-loan",
    "category": "bank",
    "description": "Unsecured business loan up to Rs. 25 Lakhs with flexible tenures.",
    "longDescription": "Active micro unit with 2 years vintage. Satisfactory credit bureau record.",
    "minAmount": 100000,
    "maxAmount": 2500000,
    "interestRate": "8.5% - 13.0%",
    "processingTime": "3 - 7 working days",
    "tenure": "1 to 5 years",
    "collateral": false,
    "documents": [
      "PAN Card",
      "Aadhaar Card",
      "6 Months Bank Statements"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Submit details",
        "description": "Submit details on IDFC First site"
      },
      {
        "step": 2,
        "title": "Authenticate records",
        "description": "Authenticate records via Account Aggregator"
      },
      {
        "step": 3,
        "title": "Sanction and disbursal",
        "description": "Sanction and disbursal"
      }
    ],
    "features": [
      "Loan amount up to ₹25 Lakh",
      "Attractive interest rate: 8.5% - 13.0%",
      "Zero collateral needed",
      "Quick processing within 3 - 7 working days"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for IDFC First Business Loan?",
        "answer": "Up to ₹25,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "Active micro unit with 2 years vintage. Satisfactory credit bureau record.",
      "minTurnover": 100000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "sole proprietor",
        "freelancer",
        "micro-enterprise"
      ]
    },
    "seo": {
      "title": "IDFC First Business Loan | MSME Business Funding",
      "description": "Unsecured business loan up to Rs. 25 Lakhs with flexible tenures."
    },
    "isActive": true,
    "popular": false
  },
  {
    "_id": "lendingkart-unsecured-loan",
    "name": "Lendingkart Unsecured Loan",
    "slug": "lendingkart-unsecured-loan",
    "category": "nbfc",
    "description": "Collateral-free business loan up to Rs. 25 Lakhs evaluated via GST.",
    "longDescription": "Minimum 2 years business vintage. Satisfactory bank statements and GST data.",
    "minAmount": 50000,
    "maxAmount": 2500000,
    "interestRate": "14.0% - 24.0%",
    "processingTime": "24 - 48 hours",
    "tenure": "12 - 36 months",
    "collateral": false,
    "documents": [
      "GST returns (12 months)",
      "PAN and Aadhaar",
      "12 Months bank statements"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Visit Lendingkart portal",
        "description": "Visit Lendingkart portal"
      },
      {
        "step": 2,
        "title": "Input details",
        "description": "Input details & link bank account"
      },
      {
        "step": 3,
        "title": "KYC check & sign contract",
        "description": "KYC check & sign contract"
      }
    ],
    "features": [
      "Loan amount up to ₹25 Lakh",
      "Attractive interest rate: 14.0% - 24.0%",
      "Zero collateral needed",
      "Quick processing within 24 - 48 hours"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for Lendingkart Unsecured Loan?",
        "answer": "Up to ₹25,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "Minimum 2 years business vintage. Satisfactory bank statements and GST data.",
      "minTurnover": 50000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "sole proprietor",
        "freelancer",
        "micro-enterprise"
      ]
    },
    "seo": {
      "title": "Lendingkart Unsecured Loan | MSME Business Funding",
      "description": "Collateral-free business loan up to Rs. 25 Lakhs evaluated via GST."
    },
    "isActive": true,
    "popular": false
  },
  {
    "_id": "flexiloans-unsecured-sme",
    "name": "FlexiLoans Unsecured SME Loan",
    "slug": "flexiloans-unsecured-sme",
    "category": "nbfc",
    "description": "Fast unsecured SME loan up to Rs. 10 Lakhs based on banking logs.",
    "longDescription": "1-year business vintage. Monthly revenue > 2 Lakhs.",
    "minAmount": 25000,
    "maxAmount": 1000000,
    "interestRate": "14.0% - 24.0%",
    "processingTime": "24 - 48 hours",
    "tenure": "12 - 36 months",
    "collateral": false,
    "documents": [
      "PAN Card",
      "Aadhaar Card",
      "6 Months Bank Statements"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Apply on",
        "description": "Apply on FlexiLoans website"
      },
      {
        "step": 2,
        "title": "Upload statements",
        "description": "Upload statements and identity proofs"
      },
      {
        "step": 3,
        "title": "Approve terms & payout",
        "description": "Approve terms & payout"
      }
    ],
    "features": [
      "Loan amount up to ₹10 Lakh",
      "Attractive interest rate: 14.0% - 24.0%",
      "Zero collateral needed",
      "Quick processing within 24 - 48 hours"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for FlexiLoans Unsecured SME Loan?",
        "answer": "Up to ₹10,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "1-year business vintage. Monthly revenue > 2 Lakhs.",
      "minTurnover": 25000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "sole proprietor",
        "freelancer",
        "micro-enterprise"
      ]
    },
    "seo": {
      "title": "FlexiLoans Unsecured SME Loan | MSME Business Funding",
      "description": "Fast unsecured SME loan up to Rs. 10 Lakhs based on banking logs."
    },
    "isActive": true,
    "popular": false
  },
  {
    "_id": "razorpay-capital-loc",
    "name": "Razorpay Capital Line of Credit",
    "slug": "razorpay-capital-loc",
    "category": "nbfc",
    "description": "Flexible line of credit up to Rs. 15 Lakhs for Razorpay merchants.",
    "longDescription": "Razorpay active merchant for min 3 months. Solid transaction volume.",
    "minAmount": 10000,
    "maxAmount": 1500000,
    "interestRate": "14.0% - 24.0%",
    "processingTime": "24 - 48 hours",
    "tenure": "12 - 36 months",
    "collateral": false,
    "documents": [
      "Razorpay Merchant ID",
      "PAN Card",
      "Aadhaar Card"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Login to",
        "description": "Login to Razorpay dashboard"
      },
      {
        "step": 2,
        "title": "Go to",
        "description": "Go to Capital LOC section to view offer"
      },
      {
        "step": 3,
        "title": "OTP authenticate",
        "description": "OTP authenticate and withdraw"
      }
    ],
    "features": [
      "Loan amount up to ₹15 Lakh",
      "Attractive interest rate: 14.0% - 24.0%",
      "Zero collateral needed",
      "Quick processing within 24 - 48 hours"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for Razorpay Capital Line of Credit?",
        "answer": "Up to ₹15,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "Razorpay active merchant for min 3 months. Solid transaction volume.",
      "minTurnover": 10000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "sole proprietor",
        "freelancer",
        "micro-enterprise"
      ]
    },
    "seo": {
      "title": "Razorpay Capital Line of Credit | MSME Business Funding",
      "description": "Flexible line of credit up to Rs. 15 Lakhs for Razorpay merchants."
    },
    "isActive": true,
    "popular": false
  },
  {
    "_id": "indifi-digital-loan",
    "name": "Indifi Digital Business Loan",
    "slug": "indifi-digital-loan",
    "category": "nbfc",
    "description": "Unsecured business loan up to Rs. 20 Lakhs using platform sales data.",
    "longDescription": "Active on partner platforms (Zomato, Amazon, etc.) or stable direct sales.",
    "minAmount": 50000,
    "maxAmount": 2000000,
    "interestRate": "14.0% - 24.0%",
    "processingTime": "24 - 48 hours",
    "tenure": "12 - 36 months",
    "collateral": false,
    "documents": [
      "PAN Card",
      "Aadhaar Card",
      "Platform dashboard logs"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Apply online on Indifi",
        "description": "Apply online on Indifi"
      },
      {
        "step": 2,
        "title": "Provide statement",
        "description": "Provide statement access for evaluation"
      },
      {
        "step": 3,
        "title": "Get approval",
        "description": "Get approval & fund transfer"
      }
    ],
    "features": [
      "Loan amount up to ₹20 Lakh",
      "Attractive interest rate: 14.0% - 24.0%",
      "Zero collateral needed",
      "Quick processing within 24 - 48 hours"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for Indifi Digital Business Loan?",
        "answer": "Up to ₹20,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "Active on partner platforms (Zomato, Amazon, etc.) or stable direct sales.",
      "minTurnover": 50000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "sole proprietor",
        "micro-enterprise"
      ]
    },
    "seo": {
      "title": "Indifi Digital Business Loan | MSME Business Funding",
      "description": "Unsecured business loan up to Rs. 20 Lakhs using platform sales data."
    },
    "isActive": true,
    "popular": false
  },
  {
    "_id": "neogrowth-mca",
    "name": "NeoGrowth MCA",
    "slug": "neogrowth-mca",
    "category": "alternative",
    "description": "POS-based cash advance up to Rs. 15 Lakhs with daily settlement linkages.",
    "longDescription": "Active card settlement POS machine. Min 6 months swipe history.",
    "minAmount": 50000,
    "maxAmount": 1500000,
    "interestRate": "1.2% - 2.0% per month",
    "processingTime": "24 hours",
    "tenure": "30 - 90 days",
    "collateral": false,
    "documents": [
      "POS statement of 1 year",
      "Business proof",
      "PAN Card"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Apply online at NeoGrowth",
        "description": "Apply online at NeoGrowth"
      },
      {
        "step": 2,
        "title": "Submit POS",
        "description": "Submit POS machine statements"
      },
      {
        "step": 3,
        "title": "Disbursal with",
        "description": "Disbursal with daily auto-deductions"
      }
    ],
    "features": [
      "Loan amount up to ₹15 Lakh",
      "Attractive interest rate: 1.2% - 2.0% per month",
      "Zero collateral needed",
      "Quick processing within 24 hours"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for NeoGrowth MCA?",
        "answer": "Up to ₹15,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "Active card settlement POS machine. Min 6 months swipe history.",
      "minTurnover": 50000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "sole proprietor",
        "micro-enterprise"
      ]
    },
    "seo": {
      "title": "NeoGrowth MCA | MSME Business Funding",
      "description": "POS-based cash advance up to Rs. 15 Lakhs with daily settlement linkages."
    },
    "isActive": true,
    "popular": false
  },
  {
    "_id": "ziploan-unsecured-loan",
    "name": "ZipLoan Unsecured Loan",
    "slug": "ziploan-unsecured-loan",
    "category": "nbfc",
    "description": "Quick unsecured business loan up to Rs. 7.5 Lakhs with minimal paper.",
    "longDescription": "Active business for at least 2 years. Annual turnover above Rs. 10 Lakhs.",
    "minAmount": 50000,
    "maxAmount": 750000,
    "interestRate": "14.0% - 24.0%",
    "processingTime": "24 - 48 hours",
    "tenure": "12 - 36 months",
    "collateral": false,
    "documents": [
      "PAN Card",
      "Aadhaar Card",
      "1 Year ITR",
      "Bank statement"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Visit ZipLoan website",
        "description": "Visit ZipLoan website"
      },
      {
        "step": 2,
        "title": "Provide profile",
        "description": "Provide profile info & upload financials"
      },
      {
        "step": 3,
        "title": "Automated appraisal",
        "description": "Automated appraisal and payout"
      }
    ],
    "features": [
      "Loan amount up to ₹8 Lakh",
      "Attractive interest rate: 14.0% - 24.0%",
      "Zero collateral needed",
      "Quick processing within 24 - 48 hours"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for ZipLoan Unsecured Loan?",
        "answer": "Up to ₹7,50,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "Active business for at least 2 years. Annual turnover above Rs. 10 Lakhs.",
      "minTurnover": 50000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "sole proprietor",
        "micro-enterprise"
      ]
    },
    "seo": {
      "title": "ZipLoan Unsecured Loan | MSME Business Funding",
      "description": "Quick unsecured business loan up to Rs. 7.5 Lakhs with minimal paper."
    },
    "isActive": true,
    "popular": false
  },
  {
    "_id": "lendingkart-line-of-credit",
    "name": "Lendingkart Line of Credit",
    "slug": "lendingkart-line-of-credit",
    "category": "nbfc",
    "description": "Revolving business line of credit up to Rs. 15 Lakhs for operational needs.",
    "longDescription": "2 years operational history. Direct GST registrations.",
    "minAmount": 50000,
    "maxAmount": 1500000,
    "interestRate": "14.0% - 24.0%",
    "processingTime": "24 - 48 hours",
    "tenure": "12 - 36 months",
    "collateral": false,
    "documents": [
      "GST returns (6 months)",
      "PAN and Aadhaar",
      "6 Months Bank Statements"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Login to Lendingkart",
        "description": "Login to Lendingkart"
      },
      {
        "step": 2,
        "title": "Select LOC,",
        "description": "Select LOC, scan bank account, e-sign contract"
      },
      {
        "step": 3,
        "title": "Draw funds as required",
        "description": "Draw funds as required"
      }
    ],
    "features": [
      "Loan amount up to ₹15 Lakh",
      "Attractive interest rate: 14.0% - 24.0%",
      "Zero collateral needed",
      "Quick processing within 24 - 48 hours"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for Lendingkart Line of Credit?",
        "answer": "Up to ₹15,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "2 years operational history. Direct GST registrations.",
      "minTurnover": 50000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "sole proprietor",
        "freelancer",
        "micro-enterprise"
      ]
    },
    "seo": {
      "title": "Lendingkart Line of Credit | MSME Business Funding",
      "description": "Revolving business line of credit up to Rs. 15 Lakhs for operational needs."
    },
    "isActive": true,
    "popular": false
  },
  {
    "_id": "kinara-capital-unsecured",
    "name": "Kinara Unsecured Mfg Loan",
    "slug": "kinara-capital-unsecured",
    "category": "nbfc",
    "description": "Unsecured loans up to Rs. 15 Lakhs for micro-manufacturing shops.",
    "longDescription": "Registered micro manufacturing unit. Min 1 year vintage.",
    "minAmount": 100000,
    "maxAmount": 1500000,
    "interestRate": "14.0% - 24.0%",
    "processingTime": "24 - 48 hours",
    "tenure": "12 - 36 months",
    "collateral": false,
    "documents": [
      "Business Registration Certificate",
      "PAN & Aadhaar",
      "6 Months Bank Statement"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Apply via Kinara Capital",
        "description": "Apply via Kinara Capital"
      },
      {
        "step": 2,
        "title": "Digital check",
        "description": "Digital check & physical shop inspection"
      },
      {
        "step": 3,
        "title": "Sanction and payout",
        "description": "Sanction and payout"
      }
    ],
    "features": [
      "Loan amount up to ₹15 Lakh",
      "Attractive interest rate: 14.0% - 24.0%",
      "Zero collateral needed",
      "Quick processing within 24 - 48 hours"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for Kinara Unsecured Mfg Loan?",
        "answer": "Up to ₹15,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "Registered micro manufacturing unit. Min 1 year vintage.",
      "minTurnover": 100000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "sole proprietor",
        "micro-enterprise"
      ]
    },
    "seo": {
      "title": "Kinara Unsecured Mfg Loan | MSME Business Funding",
      "description": "Unsecured loans up to Rs. 15 Lakhs for micro-manufacturing shops."
    },
    "isActive": true,
    "popular": false
  },
  {
    "_id": "aye-finance-unsecured",
    "name": "Aye Finance informal Loan",
    "slug": "aye-finance-unsecured",
    "category": "nbfc",
    "description": "Unsecured micro enterprise loans up to Rs. 5 Lakhs for informal traders.",
    "longDescription": "Informal retail or manufacturing. Simple cashflow based check (no ITR).",
    "minAmount": 50000,
    "maxAmount": 500000,
    "interestRate": "14.0% - 24.0%",
    "processingTime": "24 - 48 hours",
    "tenure": "12 - 36 months",
    "collateral": false,
    "documents": [
      "Aadhaar Card",
      "PAN Card",
      "Business Location Proof"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Contact Aye",
        "description": "Contact Aye Finance online"
      },
      {
        "step": 2,
        "title": "Field officer",
        "description": "Field officer visits to inspect registers"
      },
      {
        "step": 3,
        "title": "KYC check",
        "description": "KYC check & loan disbursal"
      }
    ],
    "features": [
      "Loan amount up to ₹5 Lakh",
      "Attractive interest rate: 14.0% - 24.0%",
      "Zero collateral needed",
      "Quick processing within 24 - 48 hours"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for Aye Finance informal Loan?",
        "answer": "Up to ₹5,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "Informal retail or manufacturing. Simple cashflow based check (no ITR).",
      "minTurnover": 50000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "sole proprietor",
        "micro-enterprise"
      ]
    },
    "seo": {
      "title": "Aye Finance informal Loan | MSME Business Funding",
      "description": "Unsecured micro enterprise loans up to Rs. 5 Lakhs for informal traders."
    },
    "isActive": true,
    "popular": false
  },
  {
    "_id": "lendingkart-doctor-loan",
    "name": "Lendingkart Doctor Loan",
    "slug": "lendingkart-doctor-loan",
    "category": "nbfc",
    "description": "Unsecured professional credit up to Rs. 50 Lakhs for doctors.",
    "longDescription": "Medical degree. 3 years practice. Satisfactory CIBIL.",
    "minAmount": 200000,
    "maxAmount": 5000000,
    "interestRate": "14.0% - 24.0%",
    "processingTime": "24 - 48 hours",
    "tenure": "12 - 36 months",
    "collateral": false,
    "documents": [
      "Degree Certificate",
      "MCI registration",
      "PAN and Aadhaar",
      "12 Months bank statements"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Apply on",
        "description": "Apply on Lendingkart doctor portal"
      },
      {
        "step": 2,
        "title": "Upload qualifications",
        "description": "Upload qualifications & ID proofs"
      },
      {
        "step": 3,
        "title": "Bank statements",
        "description": "Bank statements verification & disbursal"
      }
    ],
    "features": [
      "Loan amount up to ₹50 Lakh",
      "Attractive interest rate: 14.0% - 24.0%",
      "Zero collateral needed",
      "Quick processing within 24 - 48 hours"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for Lendingkart Doctor Loan?",
        "answer": "Up to ₹50,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "Medical degree. 3 years practice. Satisfactory CIBIL.",
      "minTurnover": 200000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "sole proprietor",
        "freelancer"
      ]
    },
    "seo": {
      "title": "Lendingkart Doctor Loan | MSME Business Funding",
      "description": "Unsecured professional credit up to Rs. 50 Lakhs for doctors."
    },
    "isActive": true,
    "popular": false
  },
  {
    "_id": "rxil-treds",
    "name": "RXIL TReDS Platform",
    "slug": "rxil-treds",
    "category": "alternative",
    "description": "RBI-approved TReDS platform offering digital factoring and up to 90% invoice values.",
    "longDescription": "MSME supplying goods/services to corporates, PSUs or govt. Udyam registered.",
    "minAmount": 100000,
    "maxAmount": 50000000,
    "interestRate": "1.2% - 2.0% per month",
    "processingTime": "24 hours",
    "tenure": "30 - 90 days",
    "collateral": false,
    "documents": [
      "Udyam Certificate",
      "GST details",
      "Audited Financials"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Register on",
        "description": "Register on RXIL and complete KYC"
      },
      {
        "step": 2,
        "title": "Upload unpaid",
        "description": "Upload unpaid invoices on portal"
      },
      {
        "step": 3,
        "title": "Lenders bid",
        "description": "Lenders bid competitively & select best bid"
      }
    ],
    "features": [
      "Loan amount up to ₹500 Lakh",
      "Attractive interest rate: 1.2% - 2.0% per month",
      "Zero collateral needed",
      "Quick processing within 24 hours"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for RXIL TReDS Platform?",
        "answer": "Up to ₹5,00,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "MSME supplying goods/services to corporates, PSUs or govt. Udyam registered.",
      "minTurnover": 100000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "sole proprietor",
        "micro-enterprise",
        "partnership"
      ]
    },
    "seo": {
      "title": "RXIL TReDS Platform | MSME Business Funding",
      "description": "RBI-approved TReDS platform offering digital factoring and up to 90% invoice values."
    },
    "isActive": true,
    "popular": false
  },
  {
    "_id": "m1xchange-treds",
    "name": "M1xchange TReDS",
    "slug": "m1xchange-treds",
    "category": "alternative",
    "description": "RBI-regulated digital marketplace to discount trade receivables with low interest bids.",
    "longDescription": "MSME supplying to large buyers. Registered under Udyam.",
    "minAmount": 100000,
    "maxAmount": 50000000,
    "interestRate": "1.2% - 2.0% per month",
    "processingTime": "24 hours",
    "tenure": "30 - 90 days",
    "collateral": false,
    "documents": [
      "Udyam Certificate",
      "GST details",
      "Invoice copies"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Register as",
        "description": "Register as supplier on M1xchange"
      },
      {
        "step": 2,
        "title": "Upload invoices",
        "description": "Upload invoices & get buyer approvals online"
      },
      {
        "step": 3,
        "title": "Accept best",
        "description": "Accept best bid for payout"
      }
    ],
    "features": [
      "Loan amount up to ₹500 Lakh",
      "Attractive interest rate: 1.2% - 2.0% per month",
      "Zero collateral needed",
      "Quick processing within 24 hours"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for M1xchange TReDS?",
        "answer": "Up to ₹5,00,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "MSME supplying to large buyers. Registered under Udyam.",
      "minTurnover": 100000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "sole proprietor",
        "micro-enterprise",
        "partnership"
      ]
    },
    "seo": {
      "title": "M1xchange TReDS | MSME Business Funding",
      "description": "RBI-regulated digital marketplace to discount trade receivables with low interest bids."
    },
    "isActive": true,
    "popular": false
  },
  {
    "_id": "invoicemart-treds",
    "name": "Invoicemart TReDS",
    "slug": "invoicemart-treds",
    "category": "alternative",
    "description": "RBI-regulated invoice factoring portal providing competitive discount rates.",
    "longDescription": "MSMEs trading with corporate clients. Requires Udyam certificate.",
    "minAmount": 100000,
    "maxAmount": 50000000,
    "interestRate": "1.2% - 2.0% per month",
    "processingTime": "24 hours",
    "tenure": "30 - 90 days",
    "collateral": false,
    "documents": [
      "Udyam Certificate",
      "PAN Card",
      "Unpaid Buyer Invoices"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Signup on",
        "description": "Signup on Invoicemart portal"
      },
      {
        "step": 2,
        "title": "Upload invoice",
        "description": "Upload invoice metadata and get buyer confirm"
      },
      {
        "step": 3,
        "title": "Accept discount bids",
        "description": "Accept discount bids"
      }
    ],
    "features": [
      "Loan amount up to ₹500 Lakh",
      "Attractive interest rate: 1.2% - 2.0% per month",
      "Zero collateral needed",
      "Quick processing within 24 hours"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for Invoicemart TReDS?",
        "answer": "Up to ₹5,00,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "MSMEs trading with corporate clients. Requires Udyam certificate.",
      "minTurnover": 100000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "sole proprietor",
        "micro-enterprise",
        "partnership"
      ]
    },
    "seo": {
      "title": "Invoicemart TReDS | MSME Business Funding",
      "description": "RBI-regulated invoice factoring portal providing competitive discount rates."
    },
    "isActive": true,
    "popular": false
  },
  {
    "_id": "kredx-invoice-discounting",
    "name": "KredX Invoice Discounting",
    "slug": "kredx-invoice-discounting",
    "category": "alternative",
    "description": "Private invoice discounting up to Rs. 10 Crores per invoice backed by corporate buyers.",
    "longDescription": "MSME dealing with large corporates. Invoice terms 30-90 days.",
    "minAmount": 500000,
    "maxAmount": 100000000,
    "interestRate": "1.2% - 2.0% per month",
    "processingTime": "24 hours",
    "tenure": "30 - 90 days",
    "collateral": false,
    "documents": [
      "Unpaid Invoices",
      "Corporate Buyer Agreement",
      "6 Months Bank Statements"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Register on KredX portal",
        "description": "Register on KredX portal"
      },
      {
        "step": 2,
        "title": "Vetting of",
        "description": "Vetting of buyer and supplier credit profile"
      },
      {
        "step": 3,
        "title": "Upload current",
        "description": "Upload current bills and receive cash"
      }
    ],
    "features": [
      "Loan amount up to ₹1000 Lakh",
      "Attractive interest rate: 1.2% - 2.0% per month",
      "Zero collateral needed",
      "Quick processing within 24 hours"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for KredX Invoice Discounting?",
        "answer": "Up to ₹10,00,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "MSME dealing with large corporates. Invoice terms 30-90 days.",
      "minTurnover": 500000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "sole proprietor",
        "micro-enterprise",
        "partnership"
      ]
    },
    "seo": {
      "title": "KredX Invoice Discounting | MSME Business Funding",
      "description": "Private invoice discounting up to Rs. 10 Crores per invoice backed by corporate buyers."
    },
    "isActive": true,
    "popular": false
  },
  {
    "_id": "pm-vishwakarma-stage-2",
    "name": "PM Vishwakarma Artisan Credit (Stage 2)",
    "slug": "pm-vishwakarma-stage-2",
    "category": "government",
    "description": "Concessional interest rate collateral-free loan for advanced artisans.",
    "longDescription": "Artisan holding PM Vishwakarma ID card with successful repayment of Stage 1 loan.",
    "minAmount": 100000,
    "maxAmount": 200000,
    "interestRate": "6.0% - 9.5%",
    "processingTime": "10 - 15 working days",
    "tenure": "Up to 3 years",
    "collateral": false,
    "documents": [
      "PM Vishwakarma ID Card",
      "Stage 1 Repayment Certificate",
      "Aadhaar",
      "Bank Account details"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Login to",
        "description": "Login to PM Vishwakarma portal"
      },
      {
        "step": 2,
        "title": "Select Stage",
        "description": "Select Stage 2 credit request option"
      },
      {
        "step": 3,
        "title": "Verify bank",
        "description": "Verify bank account details and submit"
      }
    ],
    "features": [
      "Loan amount up to ₹2 Lakh",
      "Attractive interest rate: 6.0% - 9.5%",
      "Zero collateral needed",
      "Quick processing within 10 - 15 working days"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for PM Vishwakarma Artisan Credit (Stage 2)?",
        "answer": "Up to ₹2,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "Artisan holding PM Vishwakarma ID card with successful repayment of Stage 1 loan.",
      "minTurnover": 100000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "sole proprietor",
        "micro-enterprise"
      ]
    },
    "seo": {
      "title": "PM Vishwakarma Artisan Credit (Stage 2) | MSME Business Funding",
      "description": "Concessional interest rate collateral-free loan for advanced artisans."
    },
    "isActive": true,
    "popular": true
  },
  {
    "_id": "pm-svanidhi-stage-3",
    "name": "PM SVANidhi Vendor Credit (Stage 3)",
    "slug": "pm-svanidhi-stage-3",
    "category": "government",
    "description": "Collateral-free micro-credit with 7% interest subsidy for street vendors.",
    "longDescription": "Active street vendors who have successfully closed their Stage 2 SVANidhi loan.",
    "minAmount": 20000,
    "maxAmount": 50000,
    "interestRate": "6.0% - 9.5%",
    "processingTime": "10 - 15 working days",
    "tenure": "Up to 7 years",
    "collateral": false,
    "documents": [
      "SVANidhi LOR Certificate",
      "Aadhaar card",
      "Voter Identity Card",
      "Repayment proof of Stage 2"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Apply online",
        "description": "Apply online on PM SVANidhi portal"
      },
      {
        "step": 2,
        "title": "Select target",
        "description": "Select target bank or lending partner"
      },
      {
        "step": 3,
        "title": "Verification and",
        "description": "Verification and direct digital disbursal"
      }
    ],
    "features": [
      "Loan amount up to ₹1 Lakh",
      "Attractive interest rate: 6.0% - 9.5%",
      "Zero collateral needed",
      "Quick processing within 10 - 15 working days"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for PM SVANidhi Vendor Credit (Stage 3)?",
        "answer": "Up to ₹50,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "Active street vendors who have successfully closed their Stage 2 SVANidhi loan.",
      "minTurnover": 20000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "sole proprietor"
      ]
    },
    "seo": {
      "title": "PM SVANidhi Vendor Credit (Stage 3) | MSME Business Funding",
      "description": "Collateral-free micro-credit with 7% interest subsidy for street vendors."
    },
    "isActive": true,
    "popular": false
  },
  {
    "_id": "sidbi-evolve-clean-finance",
    "name": "SIDBI EVOLVE Clean EV Finance",
    "slug": "sidbi-evolve-clean-finance",
    "category": "bank",
    "description": "Concessional direct finance for purchasing commercial EVs and charging setups.",
    "longDescription": "MSME entities with a minimum of 1 year of vintage looking to adopt EV logistics.",
    "minAmount": 500000,
    "maxAmount": 20000000,
    "interestRate": "8.5% - 13.0%",
    "processingTime": "3 - 7 working days",
    "tenure": "1 to 5 years",
    "collateral": false,
    "documents": [
      "UDYAM Registration Certificate",
      "Proforma Invoice of EV vehicles",
      "1 Year ITR and GST returns",
      "6 Months Bank Statements"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Apply on",
        "description": "Apply on SIDBI EVOLVE portal online"
      },
      {
        "step": 2,
        "title": "Submit vehicle",
        "description": "Submit vehicle and charging dock quotes"
      },
      {
        "step": 3,
        "title": "Verification and",
        "description": "Verification and direct payout to OEM vendors"
      }
    ],
    "features": [
      "Loan amount up to ₹200 Lakh",
      "Attractive interest rate: 8.5% - 13.0%",
      "Zero collateral needed",
      "Quick processing within 3 - 7 working days"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for SIDBI EVOLVE Clean EV Finance?",
        "answer": "Up to ₹2,00,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "MSME entities with a minimum of 1 year of vintage looking to adopt EV logistics.",
      "minTurnover": 500000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "micro-enterprise",
        "partnership"
      ]
    },
    "seo": {
      "title": "SIDBI EVOLVE Clean EV Finance | MSME Business Funding",
      "description": "Concessional direct finance for purchasing commercial EVs and charging setups."
    },
    "isActive": true,
    "popular": false
  },
  {
    "_id": "gst-sahay-invoice-credit",
    "name": "GST Sahay Digital Invoice Loan",
    "slug": "gst-sahay-invoice-credit",
    "category": "nbfc",
    "description": "Instant, collateral-free credit based on active unpaid GST invoices.",
    "longDescription": "Registered taxpayers filing regular GSTR-1 and GSTR-3B monthly/quarterly returns.",
    "minAmount": 10000,
    "maxAmount": 1000000,
    "interestRate": "14.0% - 24.0%",
    "processingTime": "24 - 48 hours",
    "tenure": "12 - 36 months",
    "collateral": false,
    "documents": [
      "GSTIN registration credentials",
      "One-time GST data sharing consent via OTP",
      "Active bank account details"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Download GST",
        "description": "Download GST Sahay partner app"
      },
      {
        "step": 2,
        "title": "Authenticate with",
        "description": "Authenticate with GSTIN details"
      },
      {
        "step": 3,
        "title": "Select approved",
        "description": "Select approved invoices for instant cash disbursal"
      }
    ],
    "features": [
      "Loan amount up to ₹10 Lakh",
      "Attractive interest rate: 14.0% - 24.0%",
      "Zero collateral needed",
      "Quick processing within 24 - 48 hours"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for GST Sahay Digital Invoice Loan?",
        "answer": "Up to ₹10,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "Registered taxpayers filing regular GSTR-1 and GSTR-3B monthly/quarterly returns.",
      "minTurnover": 10000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "sole proprietor",
        "micro-enterprise",
        "partnership"
      ]
    },
    "seo": {
      "title": "GST Sahay Digital Invoice Loan | MSME Business Funding",
      "description": "Instant, collateral-free credit based on active unpaid GST invoices."
    },
    "isActive": true,
    "popular": false
  },
  {
    "_id": "rajasthan-mlupy-subsidy",
    "name": "Rajasthan MLUPY Interest Subsidy Scheme",
    "slug": "rajasthan-mlupy-subsidy",
    "category": "government",
    "description": "Up to 8% interest subsidy on manufacturing and retail setup loans.",
    "longDescription": "Businesses setting up new units or expanding existing units within Rajasthan.",
    "minAmount": 500000,
    "maxAmount": 100000000,
    "interestRate": "6.0% - 9.5%",
    "processingTime": "10 - 15 working days",
    "tenure": "Up to 7 years",
    "collateral": true,
    "documents": [
      "Rajasthan Domicile certificate",
      "Detailed project report (DPR)",
      "UDYAM registration certificate",
      "ITR and business verification docs"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Submit application",
        "description": "Submit application on Rajasthan Single Window system"
      },
      {
        "step": 2,
        "title": "Approval by",
        "description": "Approval by District Industries Centre (DIC)"
      },
      {
        "step": 3,
        "title": "Forwarding to",
        "description": "Forwarding to partner commercial bank for disbursal"
      }
    ],
    "features": [
      "Loan amount up to ₹1000 Lakh",
      "Attractive interest rate: 6.0% - 9.5%",
      "Secured facility",
      "Quick processing within 10 - 15 working days"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for Rajasthan MLUPY Interest Subsidy Scheme?",
        "answer": "Up to ₹10,00,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "Yes, security/collateral is required."
      }
    ],
    "eligibility": {
      "businessVintage": "Businesses setting up new units or expanding existing units within Rajasthan.",
      "minTurnover": 500000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "sole proprietor",
        "micro-enterprise",
        "partnership"
      ]
    },
    "seo": {
      "title": "Rajasthan MLUPY Interest Subsidy Scheme | MSME Business Funding",
      "description": "Up to 8% interest subsidy on manufacturing and retail setup loans."
    },
    "isActive": true,
    "popular": true
  },
  {
    "_id": "phonepe-merchant-cash-advance",
    "name": "PhonePe Smart Merchant Cash Advance",
    "slug": "phonepe-merchant-cash-advance",
    "category": "alternative",
    "description": "Unsecured instant loan based dynamically on daily QR code settlement volume.",
    "longDescription": "Active PhonePe business merchants receiving daily QR code payments for at least 6 months.",
    "minAmount": 15000,
    "maxAmount": 500000,
    "interestRate": "1.2% - 2.0% per month",
    "processingTime": "24 hours",
    "tenure": "30 - 90 days",
    "collateral": false,
    "documents": [
      "Aadhaar card verification via DigiLocker",
      "PAN Card verification",
      "Digital consent to daily QR settlement deductibles"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Open PhonePe",
        "description": "Open PhonePe Business application"
      },
      {
        "step": 2,
        "title": "Click pre-approved",
        "description": "Click pre-approved offer under Loans section"
      },
      {
        "step": 3,
        "title": "Authorize with",
        "description": "Authorize with one-click Aadhaar OTP for instant cash"
      }
    ],
    "features": [
      "Loan amount up to ₹5 Lakh",
      "Attractive interest rate: 1.2% - 2.0% per month",
      "Zero collateral needed",
      "Quick processing within 24 hours"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for PhonePe Smart Merchant Cash Advance?",
        "answer": "Up to ₹5,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "Active PhonePe business merchants receiving daily QR code payments for at least 6 months.",
      "minTurnover": 15000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "sole proprietor"
      ]
    },
    "seo": {
      "title": "PhonePe Smart Merchant Cash Advance | MSME Business Funding",
      "description": "Unsecured instant loan based dynamically on daily QR code settlement volume."
    },
    "isActive": true,
    "popular": false
  },
  {
    "_id": "sidbi-carbon-offset-credit",
    "name": "SIDBI Carbon Offset Credit Line",
    "slug": "sidbi-carbon-offset-credit",
    "category": "government",
    "description": "Concessional loans for installing energy-efficient machinery and solar utilities.",
    "longDescription": "Micro manufacturing enterprises operating in energy-intensive clusters with active Udyam.",
    "minAmount": 200000,
    "maxAmount": 5000000,
    "interestRate": "6.0% - 9.5%",
    "processingTime": "10 - 15 working days",
    "tenure": "Up to 7 years",
    "collateral": false,
    "documents": [
      "Approved Energy Audit Report",
      "UDYAM Certificate",
      "Machinery purchase quotations",
      "ITR and GST returns"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Apply on",
        "description": "Apply on SIDBI Green Credit portal"
      },
      {
        "step": 2,
        "title": "Submit energy",
        "description": "Submit energy audit and cluster recommendation"
      },
      {
        "step": 3,
        "title": "Verification and",
        "description": "Verification and vendor loan disbursal"
      }
    ],
    "features": [
      "Loan amount up to ₹50 Lakh",
      "Attractive interest rate: 6.0% - 9.5%",
      "Zero collateral needed",
      "Quick processing within 10 - 15 working days"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for SIDBI Carbon Offset Credit Line?",
        "answer": "Up to ₹50,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "Micro manufacturing enterprises operating in energy-intensive clusters with active Udyam.",
      "minTurnover": 200000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "micro-enterprise",
        "partnership"
      ]
    },
    "seo": {
      "title": "SIDBI Carbon Offset Credit Line | MSME Business Funding",
      "description": "Concessional loans for installing energy-efficient machinery and solar utilities."
    },
    "isActive": true,
    "popular": false
  },
  {
    "_id": "m1xchange-bridge-loan",
    "name": "M1xchange TReDS Bridge Credit",
    "slug": "m1xchange-bridge-loan",
    "category": "alternative",
    "description": "Short-term invoice discounting against corporate and government buyers.",
    "longDescription": "MSME suppliers serving tier-1 corporate buyers or public sector undertakings (PSUs).",
    "minAmount": 100000,
    "maxAmount": 15000000,
    "interestRate": "1.2% - 2.0% per month",
    "processingTime": "24 hours",
    "tenure": "30 - 90 days",
    "collateral": false,
    "documents": [
      "Accepted digital invoice batch",
      "Buyer acknowledgement receipt",
      "GSTIN registration certificate"
    ],
    "applicationProcess": [
      {
        "step": 1,
        "title": "Upload invoices",
        "description": "Upload invoices to M1xchange portal"
      },
      {
        "step": 2,
        "title": "Multiple financiers",
        "description": "Multiple financiers place discount bids online"
      },
      {
        "step": 3,
        "title": "Select best",
        "description": "Select best bidding rate and receive cash within 24 hours"
      }
    ],
    "features": [
      "Loan amount up to ₹150 Lakh",
      "Attractive interest rate: 1.2% - 2.0% per month",
      "Zero collateral needed",
      "Quick processing within 24 hours"
    ],
    "benefits": [
      "Access capital directly from recognized banks and lending bodies.",
      "Accelerated digital sanction with dedicated expert guidance.",
      "Transparent fee structure with zero hidden bank markups."
    ],
    "faqs": [
      {
        "question": "What is the maximum loan amount for M1xchange TReDS Bridge Credit?",
        "answer": "Up to ₹1,50,00,000."
      },
      {
        "question": "Is collateral required?",
        "answer": "No collateral required for this scheme."
      }
    ],
    "eligibility": {
      "businessVintage": "MSME suppliers serving tier-1 corporate buyers or public sector undertakings (PSUs).",
      "minTurnover": 100000,
      "minCreditScore": 650,
      "additionalCriteria": [
        "micro-enterprise",
        "partnership"
      ]
    },
    "seo": {
      "title": "M1xchange TReDS Bridge Credit | MSME Business Funding",
      "description": "Short-term invoice discounting against corporate and government buyers."
    },
    "isActive": true,
    "popular": false
  }
];
export default loansData;
